 (function () {
  'use strict';

  /*
   * ============================================================
   * CUSTOM LARGE COLLECTION FILTER
   * ============================================================
   *
   * ONLY runs when:
   * #custom-large-collection-filters exists
   *
   * Used for collections with more than 5,000 products.
   *
   * Does NOT modify:
   * - Search page
   * - Part Finder
   * - Normal collections
   *
   * ============================================================
   */

  var container = document.getElementById(
    'custom-large-collection-filters'
  );

  if (!container) {
    return;
  }

  /*
   * ============================================================
   * CONFIG
   * ============================================================
   */

  var config =
    window.CustomLargeCollectionFilterConfig || {};

 var totalCollectionCount =
  Number(
    config.totalCollectionCount || 0
  );

console.log(
  'CUSTOM FILTER TOTAL COLLECTION COUNT:',
  totalCollectionCount
);

  var collectionHandle =
    config.collectionHandle ||
    container.dataset.collectionHandle ||
    '';

  var collectionUrl =
    config.collectionUrl ||
    window.location.pathname;

  var storefrontToken =
    config.storefrontToken || '';

  var endpoint =
    config.endpoint || '';


console.log(
  'CUSTOM FILTER TOTAL COLLECTION COUNT:',
  totalCollectionCount
);

  var groupsContainer =
    document.getElementById(
      'custom-filter-groups'
    );

  var statusElement =
    document.getElementById(
      'custom-filter-status'
    );

  var clearButton =
    document.getElementById(
      'custom-filter-clear'
    );

    /*
 * ============================================================
 * SELECTED FILTERS DISPLAY
 * ============================================================
 */

var selectedFiltersContainer = null;

function createSelectedFiltersContainer() {

  if (selectedFiltersContainer) {
    return selectedFiltersContainer;
  }

  selectedFiltersContainer =
    document.createElement('div');

  selectedFiltersContainer.id =
    'custom-selected-filters';

  selectedFiltersContainer.className =
    'custom-selected-filters';

  /*
   * Put selected filters directly below
   * Filter Products header.
   */

  if (container) {

    var header =
      container.querySelector(
        '.custom-filter-header'
      );

    if (header) {

      header.insertAdjacentElement(
        'afterend',
        selectedFiltersContainer
      );

    } else {

      container.insertBefore(
        selectedFiltersContainer,
        container.firstChild
      );
    }
  }

  return selectedFiltersContainer;
}

  /*
   * ============================================================
   * VALIDATION
   * ============================================================
   */

  if (!groupsContainer) {
    console.error(
      'CUSTOM FILTER ERROR: #custom-filter-groups not found.'
    );

    return;
  }

  if (
    !storefrontToken ||
    storefrontToken === 'YOUR_PUBLIC_STOREFRONT_TOKEN'
  ) {
    showError(
      'Storefront API token is not configured.'
    );

    return;
  }

  if (!endpoint) {
    showError(
      'Storefront API endpoint is not configured.'
    );

    return;
  }

  if (!collectionHandle) {
    showError(
      'Collection handle is missing.'
    );

    return;
  }

  /*
   * ============================================================
   * STATE
   * ============================================================
   */

var currentRequestId = 0;

var lastFilteredProducts = [];

var lastFilteredPageInfo = null;


/*
 * ============================================================
 * CUSTOM PAGINATION STATE
 * ============================================================
 */

var currentFilteredApiFilters = [];

var currentFilteredPage = 1;

var currentFilteredTotalCount = 0;
/*
 * Cursor used to load each page.
 *
 * Example:
 *
 * filteredPageCursors[1] = null
 * filteredPageCursors[2] = page1EndCursor
 * filteredPageCursors[3] = page2EndCursor
 *
 */
var filteredPageCursors = {
  1: null
};
  /*
   * ============================================================
   * ORIGINAL ZELLIS BACKUP
   * ============================================================
   *
   * IMPORTANT:
   *
   * The renderer can clear:
   *
   * #zellis-view
   *
   * when filters are applied/reset.
   *
   * Therefore we keep a backup of the original
   * Zellis HTML before custom filtering starts.
   *
   * ============================================================
   */

  var originalZellisBackup = null;

  var originalZellisBackupReady = false;

function getZellisView() {
  return document.getElementById(
    'zellis-view'
  );
}

/*
 * ============================================================
 * FIND EXISTING SHOPIFY PRODUCT GRID
 * ============================================================
 *
 * IMPORTANT:
 *
 * We use the existing Shopify native grid.
 *
 * We do NOT use:
 *
 * .zellis_desk
 * #zellis-view
 * #custom-api-product-grid
 *
 * ============================================================
 */

function getShopifyProductGrid() {

  var shopifyGrid =
    document.querySelector(
      '.product-grid-container.shopify_desk'
    );

  if (!shopifyGrid) {

    console.warn(
      'CUSTOM FILTER: .shopify_desk product grid not found.'
    );

    return null;
  }

  return shopifyGrid;
}


/*
 * ============================================================
 * FIND EXISTING SHOPIFY PRODUCT LIST
 * ============================================================
 */

function getShopifyProductList() {

  var shopifyGrid =
    getShopifyProductGrid();

  if (!shopifyGrid) {
    return null;
  }

  /*
   * Shopify native product list.
   */
  var productList =
    shopifyGrid.querySelector(
      'ul.product-grid'
    );

  /*
   * Fallback:
   *
   * Some Shopify themes may use another UL.
   */
  if (!productList) {

    productList =
      shopifyGrid.querySelector(
        'ul'
      );
  }

  if (!productList) {

    console.warn(
      'CUSTOM FILTER: Shopify product list not found.'
    );

    return null;
  }

  return productList;
}

  /*
   * ============================================================
   * SAVE ORIGINAL ZELLIS CONTENT
   * ============================================================
   */

  function saveOriginalZellisProducts() {
    var zellisView =
      getZellisView();

    if (!zellisView) {
      return false;
    }

    /*
     * Already saved.
     */
    if (
      originalZellisBackupReady &&
      originalZellisBackup
    ) {
      return true;
    }

    /*
     * Do not save an empty Zellis view.
     */
    if (
      !zellisView.innerHTML.trim()
    ) {
      return false;
    }

    /*
     * Create detached backup.
     *
     * We use cloneNode so the original DOM stays
     * untouched until the renderer replaces it.
     */
    originalZellisBackup =
      zellisView.cloneNode(true);

    originalZellisBackupReady = true;

    console.log(
      'CUSTOM FILTER: ORIGINAL ZELLIS BACKUP SAVED'
    );

    return true;
  }

  /*
   * ============================================================
   * RESTORE ORIGINAL ZELLIS CONTENT
   * ============================================================
   */
/*
 * ============================================================
 * RESTORE / ENABLE SHOPIFY NATIVE GRID
 * ============================================================
 *
 * IMPORTANT:
 *
 * We no longer restore Zellis products here.
 *
 * For large collections we use the existing:
 *
 * .shopify_desk
 *
 * This keeps the existing Shopify:
 *
 * - product layout
 * - sorting
 * - product count
 * - pagination
 * - native collection structure
 *
 * ============================================================
 */

function restoreOriginalZellisFallback() {

  /*
   * ----------------------------------------------------------
   * REMOVE OLD CUSTOM API GRID
   * ----------------------------------------------------------
   */

  var customGrid =
    document.getElementById(
      'custom-api-product-grid'
    );

  if (customGrid) {
    customGrid.remove();
  }


  /*
   * ----------------------------------------------------------
   * REMOVE OLD CUSTOM FILTERED GRID
   * ----------------------------------------------------------
   */

  var oldFilteredGrid =
    document.getElementById(
      'custom-filtered-product-grid'
    );

  if (oldFilteredGrid) {
    oldFilteredGrid.remove();
  }


  /*
   * ----------------------------------------------------------
   * ENABLE EXISTING SHOPIFY GRID
   * ----------------------------------------------------------
   */

  var nativeShopifyGrid =
    getShopifyProductGrid();

  if (!nativeShopifyGrid) {

    console.warn(
      'CUSTOM FILTER: .shopify_desk not found.'
    );

    return false;
  }


  /*
   * Remove old custom hidden state.
   */

  nativeShopifyGrid.removeAttribute(
    'data-custom-filter-hidden'
  );


  /*
   * Remove inline hiding.
   */

  nativeShopifyGrid.style.removeProperty(
    'display'
  );

  nativeShopifyGrid.style.removeProperty(
    'visibility'
  );

  nativeShopifyGrid.style.removeProperty(
    'opacity'
  );


  /*
   * Make sure Shopify grid is visible.
   */

  nativeShopifyGrid.style.setProperty(
    'display',
    'block',
    'important'
  );

  nativeShopifyGrid.style.setProperty(
    'visibility',
    'visible',
    'important'
  );

  nativeShopifyGrid.style.setProperty(
    'opacity',
    '1',
    'important'
  );


  /*
   * ----------------------------------------------------------
   * HIDE ZELLIS GRID
   * ----------------------------------------------------------
   *
   * We are not using Zellis anymore.
   *
   * ----------------------------------------------------------
   */

  var zellisGrid =
    document.querySelector(
      '.product-grid-container.zellis_desk'
    );

  if (zellisGrid) {

    zellisGrid.style.setProperty(
      'display',
      'none',
      'important'
    );

    zellisGrid.style.setProperty(
      'visibility',
      'hidden',
      'important'
    );

    zellisGrid.style.setProperty(
      'opacity',
      '0',
      'important'
    );
  }


  console.log(
    'CUSTOM FILTER: SHOPIFY NATIVE GRID ENABLED'
  );


  return true;
}


  /*
   * ============================================================
   * WAIT FOR ORIGINAL ZELLIS
   * ============================================================
   *
   * Zellis can render slightly after this script.
   * Try several times to capture its original markup.
   *
   * ============================================================
   */

  function startOriginalZellisCapture() {
    var attempts = 0;

    var timer =
      setInterval(function () {

        attempts++;

        if (
          saveOriginalZellisProducts()
        ) {
          clearInterval(timer);
          return;
        }

        /*
         * Try for approximately 10 seconds.
         */
        if (attempts >= 50) {
          clearInterval(timer);

          console.warn(
            'CUSTOM FILTER: ZELLIS BACKUP COULD NOT BE CREATED'
          );
        }

      }, 200);
  }

  /*
   * ============================================================
   * SHOPIFY GRAPHQL REQUEST
   * ============================================================
   */

  function shopifyRequest(
    query,
    variables
  ) {

    return fetch(
      endpoint,
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          'X-Shopify-Storefront-Access-Token':
            storefrontToken
        },

        body: JSON.stringify({
          query: query,
          variables:
            variables || {}
        })
      }
    )

      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Storefront API HTTP error: ' +
            response.status
          );
        }

        return response.json();
      })

      .then(function (result) {

        if (
          result &&
          result.errors &&
          result.errors.length
        ) {

          console.error(
            'SHOPIFY STOREFRONT API ERRORS:',
            result.errors
          );

          throw new Error(
            result.errors
              .map(function (error) {
                return error.message;
              })
              .join(', ')
          );
        }

        return result;
      });
  }

  /*
   * ============================================================
   * LOAD FILTER DEFINITIONS
   * ============================================================
   */

  function loadFilters() {

    showLoading();

    var query = `
      query GetCollectionFilters(
        $handle: String!
      ) {
        collection(handle: $handle) {
          id
          handle
          title

          products(first: 1) {
            filters {
              id
              label
              type

              values {
                id
                label
                count
                input
              }
            }
          }
        }
      }
    `;

    shopifyRequest(
      query,
      {
        handle:
          collectionHandle
      }
    )

      .then(function (result) {

        var collection =
          result &&
          result.data &&
          result.data.collection;

        if (!collection) {
          throw new Error(
            'Collection not found.'
          );
        }

        var filters =
          collection.products &&
          collection.products.filters
            ? collection.products.filters
            : [];

console.log(
  'CUSTOM FILTERS:',
  filters
);


/*
 * ============================================================
 * AVAILABILITY COUNTS
 * ============================================================
 *
 * IMPORTANT:
 *
 * Availability counts must come from the SAME product data that
 * the custom availability filter uses:
 *
 *     product.availableForSale
 *
 * Do not calculate the sidebar count as:
 *
 *     collection total - Shopify { available: false } count
 *
 * because that can differ from the custom filtered product count.
 *
 * We scan the matching collection products once and count both
 * states directly:
 *
 *     In Stock     = availableForSale === true
 *     Out of Stock = availableForSale === false
 * ============================================================
 */

var availabilityFilter =
  filters.find(
    function (filter) {

      var id =
        String(
          filter.id || ''
        ).toLowerCase();

      var label =
        String(
          filter.label || ''
        ).toLowerCase();

      return (
        id.indexOf('availability') !== -1 ||
        id.indexOf('available') !== -1 ||
        label.indexOf('availability') !== -1
      );

    }
  );


if (
  availabilityFilter &&
  availabilityFilter.values
) {

  getExactAvailabilityCounts(
    []
  )

    .then(
      function (counts) {

        counts =
          reconcileAvailabilityCounts(
            counts,
            []
          );

        availabilityFilter.values.forEach(
          function (value) {

            var valueLabel =
              String(
                value.label || ''
              )
              .trim()
              .toLowerCase();

            if (
              valueLabel === 'in stock' ||
              valueLabel.indexOf(
                'in stock'
              ) !== -1
            ) {

              value.count =
                counts.inStock;

            }

            if (
              valueLabel === 'out of stock' ||
              valueLabel.indexOf(
                'out of stock'
              ) !== -1
            ) {

              value.count =
                counts.outOfStock;

            }

          }
        );

        console.log(
          'CUSTOM AVAILABILITY COUNTS: EXACT',
          counts
        );

        renderFilters(
          filters
        );

      }
    )

    .catch(
      function (error) {

        console.error(
          'CUSTOM AVAILABILITY INITIAL COUNT ERROR:',
          error
        );

        renderFilters(
          filters
        );

      }
    );

  return;

}

/*
 * ============================================================
 * MOBILE FILTER DRAWER
 * ============================================================
 *
 * Important:
 * Filter groups are created by renderFilters().
 * Therefore mobile drawer must be initialized AFTER
 * renderFilters() has finished.
 *
 * ============================================================
 */

if (
  window.innerWidth < 992
) {

  /*
   * Small delay so the filter group DOM is completely ready.
   */
  setTimeout(
    function () {

      /*
       * If an old empty drawer exists,
       * remove it first.
       */
      var oldDrawer =
        document.getElementById(
          'custom-mobile-filter-drawer'
        );

      if (oldDrawer) {
        oldDrawer.remove();
      }

      /*
       * Create drawer again.
       *
       * At this point:
       * #custom-filter-groups
       * already contains all filters.
       */
      initMobileFilterDrawer();

      /*
       * Make sure Filter button is connected.
       */
      initMobileFilterButton();

    },
    50
  );

}
      })

      .catch(function (error) {

        console.error(
          'CUSTOM FILTER LOAD ERROR:',
          error
        );

        showError(
          'Unable to load filters. ' +
          error.message
        );
      });
  }

  /*
   * ============================================================
   * RENDER FILTERS
   * ============================================================
   */

  function renderFilters(
    filters
  ) {

    groupsContainer.innerHTML =
      '';

    if (
      !filters ||
      !filters.length
    ) {

      groupsContainer.innerHTML =
        '<div class="custom-filter-empty">' +
        'No filters available.' +
        '</div>';

      return;
    }

    filters.forEach(
      function (
        filter,
        index
      ) {

        if (
          !filter.values ||
          !filter.values.length
        ) {
          return;
        }

        var group =
          document.createElement(
            'div'
          );

        group.className =
          'custom-filter-group';

        group.dataset.filterId =
          filter.id || '';

        group.dataset.filterType =
          filter.type || '';

        /*
         * --------------------------------------------------------
         * HEADER
         * --------------------------------------------------------
         */

        var header =
          document.createElement(
            'button'
          );

        header.type =
          'button';

        header.className =
          'custom-filter-group-header';

        header.innerHTML =
          '<span class="custom-filter-group-title">' +
          escapeHtml(
            filter.label || ''
          ) +
          '</span>' +

          '<span class="custom-filter-group-arrow">' +
          '⌄' +
          '</span>';

        /*
         * --------------------------------------------------------
         * CONTENT
         * --------------------------------------------------------
         */

        var content =
          document.createElement(
            'div'
          );

        content.className =
          'custom-filter-group-content';

        /*
         * --------------------------------------------------------
         * SEARCH
         * --------------------------------------------------------
         */

        if (
          filter.values.length > 8
        ) {

          var search =
            document.createElement(
              'input'
            );

          search.type =
            'search';

          search.className =
            'custom-filter-search';

          search.placeholder =
            'Search ' +
            filter.label;

          search.setAttribute(
            'aria-label',
            'Search ' +
            filter.label
          );

          content.appendChild(
            search
          );
        }

        /*
         * --------------------------------------------------------
         * VALUES
         * --------------------------------------------------------
         */

        var values =
          document.createElement(
            'div'
          );

        values.className =
          'custom-filter-values';

        filter.values.forEach(
          function (
            value
          ) {

            var option =
              document.createElement(
                'label'
              );

            option.className =
              'custom-filter-option';

            /*
             * CHECKBOX
             */

            var checkbox =
              document.createElement(
                'input'
              );

            checkbox.type =
              'checkbox';

            checkbox.dataset.filterId =
              filter.id || '';

            checkbox.dataset.filterType =
              filter.type || '';

            checkbox.dataset.filterInput =
              typeof value.input ===
              'string'
                ? value.input
                : JSON.stringify(
                    value.input || {}
                  );

            checkbox.dataset.valueId =
              value.id || '';

            checkbox.value =
              value.id || '';

            /*
             * LABEL
             */

            var label =
              document.createElement(
                'span'
              );

            label.className =
              'custom-filter-option-label';

            label.textContent =
              value.label || '';

            /*
             * COUNT
             */

            var count =
              document.createElement(
                'span'
              );

            count.className =
              'custom-filter-option-count';

            count.textContent =
              
              Number(
                value.count || 0
              );

            /*
             * APPEND
             */

            option.appendChild(
              checkbox
            );

            option.appendChild(
              label
            );

            option.appendChild(
              count
            );

            values.appendChild(
              option
            );

            /*
             * FILTER CHANGE
             */

            checkbox.addEventListener(
  'change',
  function () {

    saveOriginalZellisProducts();

    /*
     * Show selected filter immediately.
     */

    renderSelectedFilters();

    applyFilters();

  }
);
          }
        );

        content.appendChild(
          values
        );

        group.appendChild(
          header
        );

        group.appendChild(
          content
        );

        groupsContainer.appendChild(
          group
        );

        /*
        * All filter groups open by default.
        */

        group.classList.add(
          'is-open'
        );

        /*
         * Header click.
         */

        header.addEventListener(
          'click',
          function () {

            group.classList.toggle(
              'is-open'
            );
          }
        );

        /*
         * Search values.
         */

        var searchInput =
          content.querySelector(
            '.custom-filter-search'
          );

        if (searchInput) {

          searchInput.addEventListener(
            'input',
            function () {

              var searchText =
                searchInput.value
                  .toLowerCase()
                  .trim();

              var options =
                values.querySelectorAll(
                  '.custom-filter-option'
                );

              options.forEach(
                function (
                  option
                ) {

                  var text =
                    option.textContent
                      .toLowerCase();

                  option.style.display =
                    !searchText ||
                    text.indexOf(
                      searchText
                    ) !== -1
                      ? ''
                      : 'none';
                }
              );
            }
          );
        }
      }
    );

    updateClearButton();
  }

  /*
   * ============================================================
   * GET SELECTED FILTERS
   * ============================================================
   */

  function getSelectedFilters() {

    var selected = [];

    var checkboxes =
      groupsContainer.querySelectorAll(
        'input[type="checkbox"]:checked'
      );

    checkboxes.forEach(
      function (
        checkbox
      ) {

        var input =
          checkbox.dataset.filterInput;

        if (!input) {
          return;
        }

        try {

          var parsed =
            JSON.parse(
              input
            );

          selected.push({
            filterId:
              checkbox.dataset.filterId,

            filterType:
              checkbox.dataset.filterType,

            input:
              parsed,

            valueId:
              checkbox.dataset.valueId
          });

        } catch (
          error
        ) {

          console.error(
            'INVALID FILTER INPUT:',
            input,
            error
          );
        }
      }
    );

    return selected;
  }

/* ============================================================
 * AVAILABILITY FILTER CHECK
 * ============================================================ */

function isAvailabilityFilter(item) {

  if (!item) {
    return false;
  }

  /*
   * ----------------------------------------------------------
   * CASE 1:
   * Full selected-filter object
   *
   * {
   *   filterId: "...availability...",
   *   filterType: "...",
   *   input: {
   *     available: false
   *   }
   * }
   * ----------------------------------------------------------
   */

  var filterId =
    String(
      item.filterId || ''
    ).toLowerCase();

  var filterType =
    String(
      item.filterType || ''
    ).toLowerCase();

  if (
    filterId.indexOf('availability') !== -1 ||
    filterId.indexOf('available') !== -1 ||
    filterType.indexOf('availability') !== -1 ||
    filterType.indexOf('available') !== -1
  ) {
    return true;
  }

  /*
   * ----------------------------------------------------------
   * CASE 2:
   * apiFilters contains only:
   *
   * {
   *   available: true
   * }
   *
   * or
   *
   * {
   *   available: false
   * }
   *
   * This is what applyFilters() currently creates.
   * ----------------------------------------------------------
   */

  if (
    item.input &&
    typeof item.input.available === 'boolean'
  ) {
    return true;
  }

  /*
   * ----------------------------------------------------------
   * CASE 3:
   * apiFilters itself is:
   *
   * {
   *   available: false
   * }
   * ----------------------------------------------------------
   */

  if (
    typeof item.available === 'boolean'
  ) {
    return true;
  }

  return false;
}


/* ============================================================
 * AVAILABILITY SELECTION
 * ============================================================ */

function getAvailabilitySelection(apiFilters) {

  var result = {
    inStock: false,
    outOfStock: false
  };

  if (!Array.isArray(apiFilters)) {
    return result;
  }

  apiFilters.forEach(function(item) {

    if (!isAvailabilityFilter(item)) {
      return;
    }

    var input =
      item.input &&
      typeof item.input === 'object'
        ? item.input
        : item;

    if (
      input &&
      typeof input.available === 'boolean'
    ) {

      if (input.available === true) {
        result.inStock = true;
      }

      if (input.available === false) {
        result.outOfStock = true;
      }

    }

  });

  return result;
}


/* ============================================================
 * REMOVE AVAILABILITY FILTER
 * ============================================================ */

function removeAvailabilityFilter(apiFilters) {

  if (!Array.isArray(apiFilters)) {
    return [];
  }

  return apiFilters.filter(function(item) {

    return !isAvailabilityFilter(item);

  });

}

function isOutOfStockSelected(apiFilters) {
  if (!Array.isArray(apiFilters)) {
    return false;
  }

  return apiFilters.some(function (item) {
    return (
      isAvailabilityFilter(item) &&
      item.input &&
      typeof item.input.available === 'boolean' &&
      item.input.available === false
    );
  });
}

  /*
   * ============================================================
   * UPDATE AVAILABILITY COUNTS FOR CURRENT OTHER FILTERS
   * ============================================================
   *
   * Example:
   *
   *   Brand: AISIN-AU = 4 products
   *   3 are in stock
   *   1 is out of stock
   *
   * The availability facet must therefore show:
   *
   *   In stock     3
   *   Out of stock 1
   *
   * We remove ONLY the availability filter and count
   * availableForSale on the remaining filtered products.
   *
   * This keeps the availability counts contextual to the
   * currently selected Brand / Category / etc.
   * ============================================================
   */
  function updateAvailabilityFacetCounts(apiFilters) {

    /*
     * Remove availability from the active filters.
     * Brand / Category / other selected filters remain active.
     */
    var baseFilters =
      removeAvailabilityFilter(
        apiFilters || []
      );

    console.log(
      'CUSTOM AVAILABILITY FACET COUNTS: calculating EXACTLY from',
      baseFilters
    );

    /*
     * IMPORTANT:
     *
     * Use the same availableForSale scan as the product loader.
     * This prevents:
     *
     *     sidebar count != filtered product count
     *
     * especially for In Stock.
     */
    getExactAvailabilityCounts(
      baseFilters
    )

      .then(
        function (counts) {

          counts =
            reconcileAvailabilityCounts(
              counts,
              baseFilters
            );

          /*
           * Find the Availability options already rendered.
           */
          var checkboxes =
            groupsContainer.querySelectorAll(
              'input[type="checkbox"]'
            );

          checkboxes.forEach(
            function (checkbox) {

              var option =
                checkbox.closest(
                  '.custom-filter-option'
                );

              if (!option) {
                return;
              }

              var label =
                option.querySelector(
                  '.custom-filter-option-label'
                );

              var count =
                option.querySelector(
                  '.custom-filter-option-count'
                );

              if (
                !label ||
                !count
              ) {
                return;
              }

              var labelText =
                label.textContent
                  .trim()
                  .toLowerCase();

              if (
                labelText === 'in stock' ||
                labelText.indexOf(
                  'in stock'
                ) !== -1
              ) {

                count.textContent =
                  String(
                    counts.inStock
                  );

              }

              if (
                labelText === 'out of stock' ||
                labelText.indexOf(
                  'out of stock'
                ) !== -1
              ) {

                count.textContent =
                  String(
                    counts.outOfStock
                  );

              }

            }
          );

          console.log(
            'CUSTOM AVAILABILITY FACET COUNTS: EXACT UPDATED',
            {
              total:
                counts.total,

              inStock:
                counts.inStock,

              outOfStock:
                counts.outOfStock,

              baseFilters:
                baseFilters
            }
          );

        }
      )

      .catch(
        function (error) {

          console.error(
            'CUSTOM AVAILABILITY FACET COUNTS ERROR:',
            error
          );

        }
      );

  }


  /*
   * ============================================================
   * APPLY FILTERS
   * ============================================================
   */

  function applyFilters() {

    var selected =
      getSelectedFilters();

    console.log(
      'SELECTED FILTERS:',
      selected
    );

    updateClearButton();

    /*
     * ==========================================================
     * NO FILTER SELECTED
     * ==========================================================
     */

    if (!selected.length) {

  currentRequestId++;

  lastFilteredProducts = [];

  lastFilteredPageInfo = null;

  updateURL([]);

  var currentUrl = new URL(window.location.href);

  if (!currentUrl.searchParams.has('custom_filter')) {
    window.location.reload();
    return;
  }

  restoreOriginalCollection();

  return;
}

/* ============================================================
 * MAKE API FILTER ARRAY
 * ============================================================ */

var apiFilters =
  selected.map(
    function (
      item
    ) {

      /*
       * --------------------------------------------------------
       * AVAILABILITY FILTER
       * --------------------------------------------------------
       *
       * In Stock:
       * {
       *   available: true
       * }
       *
       * Out of Stock:
       * {
       *   available: false
       * }
       *
       * Shopify Storefront API uses the `available`
       * ProductFilter field for this.
       */

      if (
        isAvailabilityFilter(item)
      ) {

        var input =
          item.input || {};

        /*
         * If Shopify already gives us
         * available:true/false, preserve it.
         */
        if (
          typeof input.available === 'boolean'
        ) {

          return {
            available:
              input.available
          };

        }

        /*
         * Fallback:
         * Read the selected checkbox label.
         */

        var availabilityCheckbox =
          groupsContainer.querySelector(
            'input[type="checkbox"][data-value-id="' +
            item.valueId +
            '"]'
          );

        if (
          availabilityCheckbox
        ) {

          var option =
            availabilityCheckbox.closest(
              '.custom-filter-option'
            );

          if (
            option
          ) {

            var optionLabel =
              option
                .querySelector(
                  '.custom-filter-option-label'
                );

            var labelText =
              optionLabel
                ? optionLabel.textContent
                    .trim()
                    .toLowerCase()
                : '';

            /*
             * IN STOCK
             */
            if (
              labelText === 'in stock' ||
              labelText.indexOf('in stock') !== -1
            ) {

              return {
                available: true
              };

            }

            /*
             * OUT OF STOCK
             */
            if (
              labelText === 'out of stock' ||
              labelText.indexOf('out of stock') !== -1
            ) {

              return {
                available: false
              };

            }
          }
        }
      }

      /*
       * --------------------------------------------------------
       * ALL OTHER FILTERS
       * --------------------------------------------------------
       */

      return item.input;
    }
  );


console.log(
  'FINAL STOREFRONT API FILTERS:',
  JSON.stringify(
    apiFilters,
    null,
    2
  )
);


/*
 * ============================================================
 * RESET PAGINATION
 * ============================================================
 */

currentFilteredPage = 1;

filteredPageCursors = {
  1: null
};

currentFilteredApiFilters =
  apiFilters;


console.log(
  'STOREFRONT API FILTERS:',
  apiFilters
);


/*
 * Update Availability counts using the other currently
 * selected filters. This is intentionally non-blocking.
 */
updateAvailabilityFacetCounts(
  apiFilters
);


/*
 * Make sure original Zellis
 * is backed up.
 */

saveOriginalZellisProducts();


loadFilteredProducts(
  apiFilters,
  null,
  1
);
  }
/*
 * ============================================================
 * LOAD FILTERED PRODUCTS
 * ============================================================
 *
 * Loads 24 products per page.
 *
 * Pagination uses Shopify Storefront API cursor.
 *
 * ============================================================
 */



/*
 * ============================================================
 * CURRENT SHOPIFY SORT
 * ============================================================
 */
function getCurrentCustomSortConfig() {

  var url =
    new URL(
      window.location.href
    );

  var sortValue =
    url.searchParams.get(
      'sort_by'
    );


  if (!sortValue) {

    var sortSelect =
      document.querySelector(
        '#SortBy'
      ) ||
      document.querySelector(
        'select[name="sort_by"]'
      );

    if (sortSelect) {
      sortValue =
        sortSelect.value;
    }

  }


  switch (sortValue) {

    case 'price-ascending':
      return {
        sortKey: 'PRICE',
        reverse: false
      };

    case 'price-descending':
      return {
        sortKey: 'PRICE',
        reverse: true
      };

    case 'title-ascending':
      return {
        sortKey: 'TITLE',
        reverse: false
      };

    case 'title-descending':
      return {
        sortKey: 'TITLE',
        reverse: true
      };

    case 'created-ascending':
      return {
        sortKey: 'CREATED_AT',
        reverse: false
      };

    case 'created-descending':
      return {
        sortKey: 'CREATED_AT',
        reverse: true
      };

    case 'best-selling':
      return {
        sortKey: 'BEST_SELLING',
        reverse: false
      };

    case 'relevance':
      return {
        sortKey: 'RELEVANCE',
        reverse: false
      };

    case 'manual':
    case 'featured':
    default:
      return {
        sortKey: 'MANUAL',
        reverse: false
      };

  }

}


/*
 * ============================================================
 * KEEP CUSTOM FILTER WHEN SORT CHANGES
 * ============================================================
 */
function bindCustomSortPreservation() {

  /*
   * IMPORTANT:
   *
   * Do NOT bind directly to #SortBy.
   *
   * Shopify/theme code may already have a change listener
   * attached to the select. In that case the theme can remove
   * custom_filter before our select listener runs.
   *
   * Therefore we listen on DOCUMENT in CAPTURE phase.
   * This runs before the target/select handlers.
   */

  if (
    document.documentElement.dataset
      .customSortDocumentBound ===
    'true'
  ) {

    return;

  }


  document.documentElement.dataset
    .customSortDocumentBound =
      'true';


  document.addEventListener(
    'change',
    function (event) {

      var target =
        event.target;


      if (
        !target ||
        !target.matches
      ) {

        return;

      }


      var isSortSelect =
        target.matches(
          '#SortBy'
        ) ||
        target.matches(
          'select[name="sort_by"]'
        );


      if (!isSortSelect) {

        return;

      }


      var currentUrl =
        new URL(
          window.location.href
        );


      var customFilter =
        currentUrl.searchParams.get(
          'custom_filter'
        );


      /*
       * No custom filter:
       * allow Shopify's normal sorting.
       */

      if (!customFilter) {

        return;

      }


      /*
       * CUSTOM FILTER IS ACTIVE.
       *
       * Stop the Shopify/theme sort handler from
       * replacing the filtered collection with all
       * collection products.
       */

      event.preventDefault();
      event.stopImmediatePropagation();


      /*
       * Preserve:
       *
       *   custom_filter
       *
       * Change only:
       *
       *   sort_by
       *
       * Reset:
       *
       *   page -> page 1
       */

      currentUrl.searchParams.set(
        'sort_by',
        target.value
      );


      currentUrl.searchParams.delete(
        'page'
      );


      console.log(
        'CUSTOM SORT: FILTER PRESERVED:',
        {
          sort:
            target.value,

          custom_filter:
            true,

          url:
            currentUrl.toString()
        }
      );


      window.location.href =
        currentUrl.toString();

    },
    true
  );

}


function loadFilteredProducts(
  apiFilters,
  afterCursor,
  pageNumber
) {

  var requestId =
    ++currentRequestId;


  if (
    typeof pageNumber !== 'number' ||
    pageNumber < 1
  ) {

    pageNumber = 1;

  }


   /*
   * ----------------------------------------------------------
   * AVAILABILITY SELECTION
   * ----------------------------------------------------------
   */

  var availabilitySelection =
    getAvailabilitySelection(
      apiFilters || []
    );

  var bothAvailabilitySelected =
    availabilitySelection.inStock &&
    availabilitySelection.outOfStock;

  var onlyInStockSelected =
    availabilitySelection.inStock &&
    !availabilitySelection.outOfStock;

  var onlyOutOfStockSelected =
    !availabilitySelection.inStock &&
    availabilitySelection.outOfStock;

  var availabilityMode =
    null;

  if (onlyInStockSelected) {

    availabilityMode =
      'in_stock';

  } else if (onlyOutOfStockSelected) {

    availabilityMode =
      'out_of_stock';

  }


  /*
   * ----------------------------------------------------------
   * SHOPIFY API FILTERS
   * ----------------------------------------------------------
   *
   * In Stock only:
   *     send { available: true }
   *
   * Both selected:
   *     remove availability filter
   *     because both = ALL products
   *
   * Out of Stock only:
   *     keep existing custom handling
   *
   * ----------------------------------------------------------
   */

var filtersForShopify =
  removeAvailabilityFilter(
    apiFilters || []
  );


/*
 * ------------------------------------------------------------
 * AVAILABILITY IS HANDLED CLIENT-SIDE
 *
 * Do NOT send:
 *
 *   { available: true }
 *   { available: false }
 *
 * because we need the actual Product.availableForSale
 * value from the returned products.
 * ------------------------------------------------------------
 */


  console.log(
    'CUSTOM AVAILABILITY SELECTION:',
    {
      inStock:
        availabilitySelection.inStock,

      outOfStock:
        availabilitySelection.outOfStock,

      both:
        bothAvailabilitySelected,

      onlyInStock:
        onlyInStockSelected,

      onlyOutOfStock:
        onlyOutOfStockSelected
    }
  );


  console.log(
    'CUSTOM AVAILABILITY MODE:',
    availabilityMode
  );


  console.log(
    'CUSTOM FILTERS FOR SHOPIFY:',
    filtersForShopify
  );


  /*
   * ----------------------------------------------------------
   * PAGINATION STATE
   * ----------------------------------------------------------
   */

  currentFilteredApiFilters =
    apiFilters || [];

  currentFilteredPage =
    pageNumber;

  filteredPageCursors[
    pageNumber
  ] =
    afterCursor || null;


  showStatus(
    'Loading products...'
  );

  hideProductGridLoading();


  /*
   * ----------------------------------------------------------
   * LOAD PRODUCTS UNTIL WE HAVE 24 MATCHING PRODUCTS
   * ----------------------------------------------------------
   */

  var matchingProducts = [];

  var currentCursor =
    afterCursor || null;

  var finalPageInfo =
    null;


  function loadNextRawPage() {

    var query = `
      query FilterCollectionProducts(
        $handle: String!,
        $filters: [ProductFilter!],
        $after: String,
        $sortKey: ProductCollectionSortKeys,
        $reverse: Boolean
      ) {

        collection(
          handle: $handle
        ) {

          id
          handle
          title

          products(
            first: 24,
            after: $after,
            filters: $filters,
            sortKey: $sortKey,
            reverse: $reverse
          ) {

            edges {

              cursor

              node {

                id
                title
                handle
                vendor
                productType
                description
                availableForSale
                tags

                featuredImage {

                  url
                  altText

                }

                metafield(
                  namespace: "custom",
                  key: "tecdoc_images_url"
                ) {

                  value

                }

                priceRange {

                  minVariantPrice {

                    amount
                    currencyCode

                  }

                  maxVariantPrice {

                    amount
                    currencyCode

                  }

                }

                variants(
                  first: 20
                ) {

                  nodes {

                    id

                    availableForSale

                    selectedOptions {

                      name
                      value

                    }

                    price {

                      amount
                      currencyCode

                    }

                    compareAtPrice {

                      amount
                      currencyCode

                    }

                  }

                }

              }

            }

            pageInfo {

              hasNextPage
              hasPreviousPage
              startCursor
              endCursor

            }

          }

        }

      }
    `;


    return shopifyRequest(
      query,
      {

        handle:
          collectionHandle,

        filters:
          filtersForShopify,

        after:
          currentCursor,

        sortKey:
          getCurrentCustomSortConfig().sortKey,

        reverse:
          getCurrentCustomSortConfig().reverse

      }
    )


      .then(
        function (result) {

          if (
            requestId !==
            currentRequestId
          ) {

            return null;

          }


          var collection =
            result &&
            result.data &&
            result.data.collection;


          if (!collection) {

            throw new Error(
              'Collection not found.'
            );

          }


          var connection =
            collection.products;


          if (!connection) {

            throw new Error(
              'Products connection not found.'
            );

          }


          var edges =
            connection.edges || [];


          /*
           * FILTER AVAILABILITY CLIENT-SIDE
           */

          edges.forEach(function(edge) {

            var product = edge.node;

            if (!product) {
              return;
            }

            if (
              availabilityMode === 'in_stock' &&
              product.availableForSale !== true
            ) {
              return;
            }

            if (
              availabilityMode === 'out_of_stock' &&
              product.availableForSale !== false
            ) {
              return;
            }

            matchingProducts.push(product);

          });


          finalPageInfo =
            connection.pageInfo ||
            null;


          /*
           * ----------------------------------------------------
           * STOP WHEN WE HAVE 24 PRODUCTS
           * ----------------------------------------------------
           */

          if (
            !availabilityMode ||
            matchingProducts.length >= 24 ||
            !(
              finalPageInfo &&
              finalPageInfo.hasNextPage
            )
          ) {

            matchingProducts =
              matchingProducts.slice(
                0,
                24
              );


            return {
              products:
                matchingProducts,

              pageInfo:
                finalPageInfo,

              collection:
                collection
            };

          }


          /*
           * ----------------------------------------------------
           * CONTINUE NEXT RAW PAGE
           * ----------------------------------------------------
           */

          currentCursor =
            finalPageInfo.endCursor;


          return loadNextRawPage();

        }
      );

  }


  /*
   * ----------------------------------------------------------
   * START REQUEST
   * ----------------------------------------------------------
   */

  loadNextRawPage()

    .then(
      function (result) {

        if (!result) {
          return;
        }


        if (
          requestId !==
          currentRequestId
        ) {

          return;

        }


        var products =
          result.products || [];


        var collection =
          result.collection;


        var pageInfo =
          result.pageInfo;


        /*
         * ------------------------------------------------------
         * SAVE PRODUCTS
         * ------------------------------------------------------
         */

        lastFilteredProducts =
          products;

        lastFilteredPageInfo =
          pageInfo;


        /*
         * ------------------------------------------------------
         * SAVE NEXT CURSOR
         * ------------------------------------------------------
         */

        if (
          pageInfo &&
          pageInfo.endCursor
        ) {

          filteredPageCursors[
            pageNumber + 1
          ] =
            pageInfo.endCursor;

        }


        /*
         * ------------------------------------------------------
         * URL
         * ------------------------------------------------------
         */

        preserveCustomFilterPageInURL(
          pageNumber
        );


        /*
         * ------------------------------------------------------
         * RENDER PRODUCTS
         * ------------------------------------------------------
         */

        notifyProductRenderer(
          products,
          collection,
          pageInfo,
          apiFilters
        );


        /*
         * IMPORTANT:
         *
         * Do NOT hide the product loader here.
         *
         * Products are rendered before the full filtered
         * product count is calculated. The count request can
         * continue for many 250-product API requests.
         *
         * Keep the loader visible until that complete operation
         * finishes.
         */


        /*
         * ------------------------------------------------------
         * TOTAL COUNT
         * ------------------------------------------------------
         */

        getFilteredProductCount(
          apiFilters
        )

          .then(
            function (totalCount) {

              if (
                requestId !==
                currentRequestId
              ) {

                return;

              }


              currentFilteredTotalCount =
                totalCount || 0;


              console.log(
                'CUSTOM FILTER TOTAL COUNT:',
                currentFilteredTotalCount
              );


              document.dispatchEvent(
                new CustomEvent(
                  'custom:large-collection-total-count',
                  {
                    detail: {

                      totalCount:
                        currentFilteredTotalCount

                    }
                  }
                )
              );


              renderCustomPagination(
                pageInfo,
                pageNumber
              );


              if (
                !products.length
              ) {

                showStatus(
                  'No products found'
                );

              } else {

                showStatus(
                  'Showing ' +
                  currentFilteredTotalCount +
                  ' filtered products'
                );

              }


              /*
               * The complete filtered count has now finished.
               *
               * Only now remove the product-area loading overlay.
               */
              hideCustomPageLoading();

            }

          )

          .catch(
            function (countError) {

              if (
                requestId !==
                currentRequestId
              ) {

                return;

              }


              console.error(
                'FILTERED PRODUCT COUNT ERROR:',
                countError
              );


              /*
               * Even if the count request fails, do not leave
               * the product-area loader stuck forever.
               */
              hideCustomPageLoading();

              showError(
                'Unable to count filtered products. ' +
                countError.message
              );

            }
          );

      }
    )

    .catch(
      function (error) {

        if (
          requestId !==
          currentRequestId
        ) {

          return;

        }


        console.error(
          'FILTERED PRODUCT ERROR:',
          error
        );


        showError(
          'Unable to filter products. ' +
          error.message
        );

      }
    );

}



/*
 * ============================================================
 * GET TOTAL FILTERED PRODUCT COUNT
 * ============================================================
 *
 * Shopify Storefront ProductConnection does not expose
 * totalCount.
 *
 * Therefore:
 *
 * 250 products are requested at a time and counted until
 * hasNextPage becomes false.
 *
 * This function only returns the COUNT.
 *
 * It does NOT render products.
 *
 * ============================================================
 */

/*
 * ============================================================
 * CUSTOM PAGINATION REQUEST
 * ============================================================
 */

document.addEventListener(
  'custom:large-collection-page-request',
  function (event) {

    var detail =
      event.detail || {};

    var pageNumber =
      Number(
        detail.pageNumber
      );

    if (
      !pageNumber ||
      pageNumber < 1
    ) {
      pageNumber = 1;
    }

    /*
     * Make sure filters still exist.
     */
    if (
      !currentFilteredApiFilters ||
      !currentFilteredApiFilters.length
    ) {
      return;
    }

    /*
     * Cursor for requested page.
     */
    var afterCursor =
      filteredPageCursors[
        pageNumber
      ];

    /*
     * If cursor does not exist,
     * we cannot jump to that page yet.
     */
    if (
      pageNumber > 1 &&
      !afterCursor
    ) {
      console.warn(
        'CUSTOM PAGINATION: Cursor not available for page',
        pageNumber
      );

      return;
    }

    loadFilteredProducts(
      currentFilteredApiFilters,
      afterCursor || null,
      pageNumber
    );

  }
);

/* ============================================================
 * EXACT AVAILABILITY COUNT
 *
 * IMPORTANT:
 *
 * Do NOT use Shopify:
 *
 *   filters: [{ available: true/false }]
 *
 * because Shopify's available filter does not match
 * the required business Out of Stock count.
 *
 * Instead:
 *
 * 1. Load collection products.
 * 2. Read product.availableForSale.
 * 3. Count true / false directly.
 *
 * Therefore:
 *
 * In Stock     = availableForSale === true
 * Out of Stock = availableForSale === false
 * ============================================================
 */

function getCanonicalCollectionProductCount() {

  var container =
    document.getElementById(
      'custom-large-collection-filters'
    );

  if (container) {

    var dataCount =
      Number(
        container.getAttribute(
          'data-collection-count'
        )
      );

    if (Number.isFinite(dataCount) && dataCount >= 0) {
      return dataCount;
    }

  }

  /* Fallback: read the customer-facing Shopify count. */
  var countElements = [
    document.getElementById('ProductCountDesktop'),
    document.getElementById('ProductCountMobile')
  ];

  for (var i = 0; i < countElements.length; i++) {

    var element = countElements[i];

    if (!element) {
      continue;
    }

    var text =
      String(element.textContent || '').trim();

    var match =
      text.match(/(?:of\s+)?([\d,]+)\s+products?/i);

    if (match) {

      var value =
        Number(
          match[1].replace(/,/g, '')
        );

      if (Number.isFinite(value) && value >= 0) {
        return value;
      }

    }

  }

  return null;

}


function reconcileAvailabilityCounts(
  counts,
  baseFilters
) {

  counts = counts || {
    total: 0,
    inStock: 0,
    outOfStock: 0
  };

  var filters =
    Array.isArray(baseFilters)
      ? baseFilters
      : [];

  /* Only reconcile the completely unfiltered collection. */
  if (filters.length !== 0) {
    return counts;
  }

  var canonicalTotal =
    getCanonicalCollectionProductCount();

  if (
    canonicalTotal === null ||
    !Number.isFinite(canonicalTotal)
  ) {
    return counts;
  }

  var apiTotal =
    Number(counts.total) || 0;

  var difference =
    apiTotal - canonicalTotal;

  /*
   * Keep the exact out-of-stock count and reconcile only the API
   * excess against the in-stock side. This makes both availability
   * counts add up to the same canonical collection total displayed
   * by the storefront.
   */
  if (difference > 0) {

    counts.inStock =
      Math.max(
        0,
        (Number(counts.inStock) || 0) - difference
      );

  }

  counts.outOfStock =
    Math.max(
      0,
      Math.min(
        Number(counts.outOfStock) || 0,
        canonicalTotal
      )
    );

  counts.inStock =
    Math.max(
      0,
      Math.min(
        Number(counts.inStock) || 0,
        Math.max(0, canonicalTotal - counts.outOfStock)
      )
    );

  counts.total =
    canonicalTotal;

  return counts;

}


function getExactAvailabilityCounts(
  baseFilters
) {

  baseFilters =
    Array.isArray(baseFilters)
      ? baseFilters
      : [];

  var counts = {
    total: 0,
    inStock: 0,
    outOfStock: 0
  };

  var cursor = null;

  var query = `
    query ExactAvailabilityCounts(
      $handle: String!,
      $filters: [ProductFilter!],
      $after: String
    ) {

      collection(
        handle: $handle
      ) {

        products(
          first: 250,
          after: $after,
          filters: $filters
        ) {

          edges {

            node {

              id

              availableForSale

            }

          }

          pageInfo {

            hasNextPage

            endCursor

          }

        }

      }

    }
  `;

  function getNextPage() {

    return shopifyRequest(
      query,
      {

        handle:
          collectionHandle,

        filters:
          baseFilters,

        after:
          cursor

      }
    )

      .then(
        function (result) {

          var collection =
            result &&
            result.data &&
            result.data.collection;

          if (!collection) {

            throw new Error(
              'Collection not found while counting availability.'
            );

          }

          var products =
            collection.products;

          if (!products) {

            return counts;

          }

          var edges =
            products.edges || [];

          edges.forEach(
            function (edge) {

              var product =
                edge &&
                edge.node;

              if (!product) {
                return;
              }

              counts.total++;

              if (
                product.availableForSale === true
              ) {

                counts.inStock++;

              } else {

                counts.outOfStock++;

              }

            }
          );

          console.log(
            'EXACT AVAILABILITY COUNT PAGE:',
            {
              pageItems:
                edges.length,

              runningTotal:
                counts.total,

              inStock:
                counts.inStock,

              outOfStock:
                counts.outOfStock,

              filters:
                baseFilters
            }
          );

          if (
            products.pageInfo &&
            products.pageInfo.hasNextPage &&
            products.pageInfo.endCursor
          ) {

            cursor =
              products.pageInfo.endCursor;

            return getNextPage();

          }

          console.log(
            'EXACT AVAILABILITY COUNT COMPLETE:',
            counts
          );

          return counts;

        }
      );

  }

  return getNextPage();

}


function getExactAvailabilityCount(
  isAvailable,
  baseFilters
) {

  var totalCount = 0;

  var cursor = null;

  /*
   * ----------------------------------------------------------
   * Base filters = all filters except availability.
   *
   * Example:
   *
   * [
   *   {
   *     productVendor: "TRW"
   *   }
   * ]
   *
   * Availability itself is checked using:
   *
   * product.availableForSale
   * ----------------------------------------------------------
   */

  baseFilters =
    Array.isArray(baseFilters)
      ? baseFilters
      : [];


  function getNextPage() {

    var query = `
      query ExactAvailabilityCount(
        $handle: String!,
        $filters: [ProductFilter!],
        $after: String
      ) {

        collection(
          handle: $handle
        ) {

          products(
            first: 250,
            after: $after,
            filters: $filters
          ) {

            edges {

              node {

                id

                availableForSale

              }

            }

            pageInfo {

              hasNextPage

              endCursor

            }

          }

        }

      }
    `;


    return shopifyRequest(
      query,
      {

        handle:
          collectionHandle,

        filters:
          baseFilters,

        after:
          cursor

      }
    )

      .then(
        function(result) {

          var collection =
            result &&
            result.data &&
            result.data.collection;


          if (!collection) {

            throw new Error(
              'Collection not found while counting availability.'
            );

          }


          var products =
            collection.products;


          if (!products) {
            return totalCount;
          }


          var edges =
            products.edges || [];


          edges.forEach(
            function(edge) {

              var product =
                edge.node;


              if (!product) {
                return;
              }


              if (
                product.availableForSale ===
                isAvailable
              ) {

                totalCount++;

              }

            }
          );


          console.log(
            'EXACT AVAILABILITY COUNT PAGE:',
            {
              available:
                isAvailable,

              pageItems:
                edges.length,

              runningTotal:
                totalCount,

              filters:
                baseFilters
            }
          );


          if (
            products.pageInfo &&
            products.pageInfo.hasNextPage
          ) {

            cursor =
              products.pageInfo.endCursor;

            return getNextPage();

          }


          console.log(
            'EXACT AVAILABILITY COUNT COMPLETE:',
            isAvailable
              ? 'IN STOCK'
              : 'OUT OF STOCK',

            totalCount
          );


          return totalCount;

        }
      );

  }


  return getNextPage();

}


function getFilteredProductCountFromShopify(
  apiFilters
) {

  var totalCount = 0;

  var cursor = null;


  function getNextPage() {

    var countQuery = `
      query CountFilteredCollectionProducts(
        $handle: String!,
        $filters: [ProductFilter!],
        $after: String
      ) {

        collection(
          handle: $handle
        ) {

          products(
            first: 250,
            after: $after,
            filters: $filters
          ) {

            edges {

              node {
                id
              }

            }

            pageInfo {

              hasNextPage

              endCursor

            }

          }

        }

      }
    `;


    return shopifyRequest(
      countQuery,
      {

        handle:
          collectionHandle,

        filters:
          apiFilters || [],

        after:
          cursor

      }
    )

      .then(
        function (result) {

          var collection =
            result &&
            result.data &&
            result.data.collection;


          if (!collection) {

            throw new Error(
              'Collection not found while counting products.'
            );

          }


          var connection =
            collection.products;


          if (!connection) {

            throw new Error(
              'Products connection not found while counting products.'
            );

          }


          var edges =
            connection.edges || [];


          totalCount +=
            edges.length;


          console.log(
            'COUNT PAGE:',
            edges.length,
            'MATCHING TOTAL:',
            totalCount
          );


          if (
            connection.pageInfo &&
            connection.pageInfo.hasNextPage
          ) {

            cursor =
              connection.pageInfo.endCursor;

            return getNextPage();

          }


          return totalCount;

        }
      );

  }


  return getNextPage();

}

function getFilteredProductCount(apiFilters) {

  apiFilters =
    Array.isArray(apiFilters)
      ? apiFilters
      : [];

  var availabilitySelection =
    getAvailabilitySelection(
      apiFilters
    );

  var baseFilters =
    removeAvailabilityFilter(
      apiFilters
    );

  var bothAvailabilitySelected =
    availabilitySelection.inStock &&
    availabilitySelection.outOfStock;

  if (bothAvailabilitySelected) {

    if (baseFilters.length === 0) {

      var canonicalBoth =
        getCanonicalCollectionProductCount();

      if (
        canonicalBoth !== null &&
        Number.isFinite(canonicalBoth)
      ) {
        return Promise.resolve(canonicalBoth);
      }

    }

    return getFilteredProductCountFromShopify(
      baseFilters
    );

  }

  if (availabilitySelection.inStock) {

    if (baseFilters.length === 0) {

      var canonicalInStock =
        getCanonicalCollectionProductCount();

      if (
        canonicalInStock !== null &&
        Number.isFinite(canonicalInStock)
      ) {

        return getExactAvailabilityCount(
          false,
          []
        )
          .then(
            function (outOfStockCount) {

              return Math.max(
                0,
                canonicalInStock -
                (Number(outOfStockCount) || 0)
              );

            }
          );

      }

    }

    return getExactAvailabilityCount(
      true,
      baseFilters
    );

  }

  if (availabilitySelection.outOfStock) {

    return getExactAvailabilityCount(
      false,
      baseFilters
    );

  }

  if (apiFilters.length === 0) {

    var canonicalTotal =
      getCanonicalCollectionProductCount();

    if (
      canonicalTotal !== null &&
      Number.isFinite(canonicalTotal)
    ) {
      return Promise.resolve(canonicalTotal);
    }

  }

  return getFilteredProductCountFromShopify(
    apiFilters
  );

}


function ensureFilteredPageCursor(
  targetPage
) {

  targetPage =
    Number(targetPage);


  /*
   * Page 1 does not need a cursor.
   */

  if (
    !targetPage ||
    targetPage <= 1
  ) {

    return Promise.resolve(
      null
    );

  }


  /*
   * ----------------------------------------------------------
   * CURSOR ALREADY EXISTS
   * ----------------------------------------------------------
   */

  if (
    Object.prototype.hasOwnProperty.call(
      filteredPageCursors,
      targetPage
    )
  ) {

    return Promise.resolve(
      filteredPageCursors[
        targetPage
      ]
    );

  }


  /*
   * ==========================================================
   * FAST DIRECT PAGE JUMP
   * ==========================================================
   *
   * OLD BEHAVIOUR:
   *
   *   first: 24
   *
   * To open page 191, the code had to request:
   *
   *   page 2
   *   page 3
   *   page 4
   *   ...
   *   page 191
   *
   * That means roughly 190 API requests.
   *
   * NEW BEHAVIOUR:
   *
   * Shopify allows up to 250 products in one connection.
   *
   * We therefore fetch 250 products per cursor request and
   * take the exact cursor belonging to:
   *
   *   (targetPage - 1) * 24
   *
   * Example:
   *
   *   Page 191
   *   = after product 4560
   *
   *   4560 / 250
   *   = about 19 requests
   *
   * So page 191 no longer requires 190 sequential requests.
   *
   * IMPORTANT:
   * This function ONLY builds the cursor.
   * The actual page is still rendered by loadFilteredProducts()
   * with first: 24, so the existing product rendering remains
   * unchanged.
   * ==========================================================
   */


  var productsBeforeTarget =
    (
      targetPage - 1
    ) * 24;


  var availabilitySelection =
    getAvailabilitySelection(
      currentFilteredApiFilters || []
    );

  var availabilityMode =
    null;

  if (
    availabilitySelection.inStock &&
    !availabilitySelection.outOfStock
  ) {
    availabilityMode = 'in_stock';
  } else if (
    availabilitySelection.outOfStock &&
    !availabilitySelection.inStock
  ) {
    availabilityMode = 'out_of_stock';
  }

  var cursorFilters =
    removeAvailabilityFilter(
      currentFilteredApiFilters || []
    );


  var scannedProducts =
    0;

  var matchingProductsBeforeChunk =
    0;


  var afterCursor =
    null;


  var query = `
    query FastFilteredPageCursor(
      $handle: String!,
      $filters: [ProductFilter!],
      $after: String,
      $sortKey: ProductCollectionSortKeys,
      $reverse: Boolean
    ) {

      collection(
        handle: $handle
      ) {

        products(
          first: 250,
          after: $after,
          filters: $filters,
          sortKey: $sortKey,
          reverse: $reverse
        ) {

          edges {

            cursor

          }

          pageInfo {

            hasNextPage
            endCursor

          }

        }

      }

    }
  `;


  function findCursorChunk() {

    return shopifyRequest(
      query,
      {
        handle:
          collectionHandle,

        filters:
          cursorFilters,

        after:
          afterCursor,

        sortKey:
          getCurrentCustomSortConfig().sortKey,

        reverse:
          getCurrentCustomSortConfig().reverse
      }
    )

      .then(
        function (result) {

          var connection =
            result &&
            result.data &&
            result.data.collection &&
            result.data.collection.products;


          if (!connection) {

            throw new Error(
              'Unable to get direct page cursor.'
            );

          }


          var edges =
            connection.edges || [];


          /*
           * ----------------------------------------------------
           * DOES THIS 250-PRODUCT CHUNK CONTAIN THE TARGET?
           * ----------------------------------------------------
           */

          var chunkStart =
            scannedProducts;


          var chunkEnd =
            scannedProducts +
            edges.length;


          var matchingEdges =
            edges.filter(function(edge) {

              if (!availabilityMode) {
                return true;
              }

              var available =
                edge &&
                edge.node &&
                edge.node.availableForSale === true;

              return availabilityMode === 'in_stock'
                ? available
                : !available;

            });

          var matchingChunkStart =
            matchingProductsBeforeChunk;

          var matchingChunkEnd =
            matchingProductsBeforeChunk +
            matchingEdges.length;


          if (
            productsBeforeTarget > 0 &&
            productsBeforeTarget <= matchingChunkEnd
          ) {

            /*
             * productsBeforeTarget is 1-based here.
             *
             * Example:
             *
             * Page 2:
             *   productsBeforeTarget = 24
             *   cursor = edges[23]
             *
             * Page 191:
             *   productsBeforeTarget = 4560
             */

            var cursorIndex =
              productsBeforeTarget -
              matchingChunkStart -
              1;


            var targetEdge =
              matchingEdges[
                cursorIndex
              ];


            if (
              targetEdge &&
              targetEdge.cursor
            ) {

              filteredPageCursors[
                targetPage
              ] =
                targetEdge.cursor;


              console.log(
                'CUSTOM PAGINATION: FAST CURSOR FOUND:',
                {
                  page:
                    targetPage,

                  productsBeforeTarget:
                    productsBeforeTarget,

                  apiRequests:
                    Math.ceil(
                      chunkEnd / 250
                    ),

                  cursor:
                    targetEdge.cursor
                }
              );


              return targetEdge.cursor;

            }

          }


          /*
           * ----------------------------------------------------
           * END OF FILTERED COLLECTION
           * ----------------------------------------------------
           */

          if (
            !connection.pageInfo ||
            !connection.pageInfo.hasNextPage ||
            !connection.pageInfo.endCursor ||
            !edges.length
          ) {

            console.warn(
              'CUSTOM PAGINATION: Target page does not exist:',
              targetPage,
              {
                productsFound:
                  matchingProductsBeforeChunk,

                productsRequired:
                  productsBeforeTarget
              }
            );


            return null;

          }


          /*
           * ----------------------------------------------------
           * CONTINUE WITH NEXT 250-PRODUCT CHUNK
           * ----------------------------------------------------
           */

          scannedProducts =
            chunkEnd;

          matchingProductsBeforeChunk =
            matchingChunkEnd;


          afterCursor =
            connection.pageInfo.endCursor;


          return findCursorChunk();

        }
      );

  }


  return findCursorChunk();

}

/*
 * ============================================================
 * REQUEST ANY FILTERED PAGE
 * ============================================================
 */

function requestFilteredPage(
  pageNumber
) {

  pageNumber =
    Number(pageNumber);


  if (
    !pageNumber ||
    pageNumber < 1
  ) {

    pageNumber = 1;

  }


  console.log(
    'CUSTOM PAGINATION: REQUEST PAGE:',
    pageNumber
  );


  /*
   * ----------------------------------------------------------
   * LOADING
   * ----------------------------------------------------------
   */

  showCustomPageLoading();


  /*
   * ----------------------------------------------------------
   * SCROLL TO PRODUCT GRID
   * ----------------------------------------------------------
   */

  scrollToCustomProductGrid();


  /*
   * ----------------------------------------------------------
   * PAGE 1
   * ----------------------------------------------------------
   */

  if (
    pageNumber === 1
  ) {

    preserveCustomFilterPageInURL(
      1
    );


    loadFilteredProducts(
      currentFilteredApiFilters,
      null,
      1
    );


    return;

  }


  /*
   * ----------------------------------------------------------
   * BUILD / GET CURSOR
   * ----------------------------------------------------------
   */

  ensureFilteredPageCursor(
    pageNumber
  )

    .then(
      function (cursor) {

        /*
         * Cursor not available.
         */

        if (!cursor) {

          hideCustomPageLoading();


          console.warn(
            'CUSTOM PAGINATION: Unable to create cursor for page:',
            pageNumber
          );


          return;

        }


        console.log(
          'CUSTOM PAGINATION: LOADING PAGE:',
          pageNumber,
          'CURSOR:',
          cursor
        );


        /*
         * ----------------------------------------------------
         * LOAD PRODUCTS
         * ----------------------------------------------------
         */

        loadFilteredProducts(
          currentFilteredApiFilters,
          cursor,
          pageNumber
        );

      }
    )

    .catch(
      function (error) {

        hideCustomPageLoading();


        console.error(
          'CUSTOM PAGINATION ERROR:',
          error
        );


        showError(
          'Unable to load page ' +
          pageNumber +
          '. ' +
          error.message
        );

      }
    );

}

/*
 * ============================================================
 * CUSTOM PAGINATION
 * ============================================================
 *
 * Layout:
 *
 *   ‹  1  2  3  4  5  ...  18  ›
 *
 * Also:
 *
 * - Scroll to product grid when page changes
 * - Show loading overlay
 * - Hide loading overlay after products load
 * - Keep pagination below product grid
 *
 * ============================================================
 */

function renderCustomPagination(
  pageInfo,
  pageNumber
) {

  /*
   * Use the EXISTING Shopify product grid container.
   * Do not use zellisView because zellis_desk is hidden.
   */

  var shopifyGrid =
    document.querySelector(
      '.product-grid-container.shopify_desk'
    );

  if (!shopifyGrid) {
    return;
  }


  /*
   * Hide Shopify's original pagination
   * while custom filters are active.
   *
   * Otherwise the original collection count
   * shows pagination like 375 for 8994 products.
   */

  var nativePagination =
    shopifyGrid.querySelector(
      '.pagination'
    );

  if (nativePagination) {

    nativePagination.style.setProperty(
      'display',
      'none',
      'important'
    );

  }


  /*
   * Also support themes where pagination
   * is not inside .pagination.
   */

  shopifyGrid
    .querySelectorAll(
      'nav[aria-label*="Pagination" i]'
    )
    .forEach(
      function (element) {

        if (
          element.id !==
          'custom-api-pagination'
        ) {

          element.style.setProperty(
            'display',
            'none',
            'important'
          );

        }

      }
    );


  /*
   * ----------------------------------------------------------
   * REMOVE OLD PAGINATION
   * ----------------------------------------------------------
   */

  var oldPagination =
    document.getElementById(
      'custom-api-pagination'
    );

  if (oldPagination) {
    oldPagination.remove();
  }


  /*
   * ----------------------------------------------------------
   * PAGE DATA
   * ----------------------------------------------------------
   */

  if (!pageInfo) {
    return;
  }


  if (
    !lastFilteredProducts ||
    !lastFilteredProducts.length
  ) {
    return;
  }


  currentFilteredPage =
    pageNumber;


  /*
   * ----------------------------------------------------------
   * TOTAL PAGES
   * ----------------------------------------------------------
   */

  var totalPages =
    Math.max(
      1,
      Math.ceil(
        currentFilteredTotalCount / 24
      )
    );


  /*
   * ----------------------------------------------------------
   * MAIN PAGINATION
   * ----------------------------------------------------------
   */

  var pagination =
    document.createElement(
      'nav'
    );

  pagination.id =
    'custom-api-pagination';

  pagination.className =
    'custom-api-pagination';

  pagination.setAttribute(
    'aria-label',
    'Pagination'
  );


  /*
   * ----------------------------------------------------------
   * PREVIOUS ARROW
   * ----------------------------------------------------------
   */

  var previousButton =
    document.createElement(
      'button'
    );

  previousButton.type =
    'button';

  previousButton.className =
    'custom-pagination-arrow custom-pagination-prev';

  previousButton.innerHTML =
    '&lsaquo;';

  previousButton.setAttribute(
    'aria-label',
    'Previous page'
  );

  previousButton.disabled =
    pageNumber <= 1 ||
    !pageInfo.hasPreviousPage;


  /*
   * ----------------------------------------------------------
   * PREVIOUS CLICK
   * ----------------------------------------------------------
   */

  previousButton.addEventListener(
    'click',
    function () {

      if (
        previousButton.disabled
      ) {
        return;
      }


      var previousPage =
        pageNumber - 1;


      if (
        previousPage < 1
      ) {
        return;
      }


      requestFilteredPage(
        previousPage
      );

    }
  );


  pagination.appendChild(
    previousButton
  );


  /*
   * ----------------------------------------------------------
   * PAGE NUMBERS
   * ----------------------------------------------------------
   */

  var pageNumbers =
    getPaginationPages(
      pageNumber,
      totalPages
    );


  pageNumbers.forEach(
    function (page) {

      /*
       * Ellipsis
       */

      if (
        page === '...'
      ) {

        var dots =
          document.createElement(
            'span'
          );

        dots.className =
          'custom-pagination-dots';

        dots.textContent =
          '...';

        pagination.appendChild(
          dots
        );

        return;
      }


      /*
       * Page button
       */

      var pageButton =
        document.createElement(
          'button'
        );

      pageButton.type =
        'button';

      pageButton.className =
        'custom-pagination-number';


      pageButton.textContent =
        page;


      /*
       * Current page
       */

      if (
        page === pageNumber
      ) {

        pageButton.classList.add(
          'is-active'
        );

        pageButton.setAttribute(
          'aria-current',
          'page'
        );

      }


      /*
       * ------------------------------------------------------
       * PAGE CLICK
       * ------------------------------------------------------
       */

     pageButton.addEventListener(
  'click',
  function () {

    if (
      page === pageNumber
    ) {
      return;
    }

    console.log(
      'CUSTOM PAGINATION: PAGE CLICK:',
      page
    );

    /*
     * Always use requestFilteredPage().
     *
     * It will:
     * 1. Check existing cursor
     * 2. Build cursor if required
     * 3. Load requested page
     */

    requestFilteredPage(
      page
    );

  }
);


      pagination.appendChild(
        pageButton
      );

    }
  );


  /*
   * ----------------------------------------------------------
   * NEXT ARROW
   * ----------------------------------------------------------
   */

  var nextButton =
    document.createElement(
      'button'
    );

  nextButton.type =
    'button';

  nextButton.className =
    'custom-pagination-arrow custom-pagination-next';

  nextButton.innerHTML =
    '&rsaquo;';

  nextButton.setAttribute(
    'aria-label',
    'Next page'
  );

  nextButton.disabled =
    !pageInfo.hasNextPage;


  /*
   * ----------------------------------------------------------
   * NEXT CLICK
   * ----------------------------------------------------------
 */

  nextButton.addEventListener(
  'click',
  function () {

    if (
      nextButton.disabled
    ) {
      return;
    }

    var nextPage =
      pageNumber + 1;

    if (
      nextPage > totalPages
    ) {
      return;
    }

    requestFilteredPage(
      nextPage
    );

  }
);


  pagination.appendChild(
    nextButton
  );


  /*
   * ----------------------------------------------------------
   * ADD PAGINATION BELOW GRID
   * ----------------------------------------------------------
   */

  shopifyGrid.appendChild(
  pagination
);


  /*
   * ----------------------------------------------------------
   * ADD CSS
   * ----------------------------------------------------------
   */

  addCustomPaginationStyles();

}


/*
 * ============================================================
 * PAGINATION PAGE LIST
 * ============================================================
 *
 * Example:
 *
 * Page 1:
 * 1 2 3 4 5 ... 18
 *
 * Page 4:
 * 1 2 3 4 5 ... 18
 *
 * Page 9:
 * 1 ... 7 8 9 10 11 ... 18
 *
 * Page 18:
 * 1 ... 14 15 16 17 18
 *
 * ============================================================
 */

function getPaginationPages(
  currentPage,
  totalPages
) {

  var pages = [];


  /*
   * Small number of pages.
   */

  if (
    totalPages <= 7
  ) {

    for (
      var i = 1;
      i <= totalPages;
      i++
    ) {

      pages.push(i);

    }

    return pages;

  }


  /*
   * ----------------------------------------------------------
   * FIRST PAGES
   * ----------------------------------------------------------
   */

  if (
    currentPage <= 4
  ) {

    pages.push(1);
    pages.push(2);
    pages.push(3);
    pages.push(4);
    pages.push(5);
    pages.push('...');
    pages.push(totalPages);

    return pages;

  }


  /*
   * ----------------------------------------------------------
   * LAST PAGES
   * ----------------------------------------------------------
   */

  if (
    currentPage >=
    totalPages - 3
  ) {

    pages.push(1);
    pages.push('...');

    pages.push(
      totalPages - 4
    );

    pages.push(
      totalPages - 3
    );

    pages.push(
      totalPages - 2
    );

    pages.push(
      totalPages - 1
    );

    pages.push(
      totalPages
    );

    return pages;

  }


  /*
   * ----------------------------------------------------------
   * MIDDLE
   * ----------------------------------------------------------
   */

  pages.push(1);
  pages.push('...');

  pages.push(
    currentPage - 1
  );

  pages.push(
    currentPage
  );

  pages.push(
    currentPage + 1
  );

  pages.push('...');

  pages.push(totalPages);


  return pages;

}


/*
 * ============================================================
 * SHOW LOADING OVERLAY
 * ============================================================
 */

function showCustomPageLoading() {

  /*
   * ----------------------------------------------------------
   * TARGET ONLY THE PRODUCT AREA
   * ----------------------------------------------------------
   *
   * The loader should appear over the product cards,
   * not over the filter sidebar / sort controls.
   */

  var productArea =
    document.querySelector(
      '.product-grid-container.shopify_desk .product-grid'
    );


  /*
   * Fallback for themes where .product-grid is not found.
   */

  if (!productArea) {

    productArea =
      document.querySelector(
        '.product-grid-container.shopify_desk'
      );

  }


  if (!productArea) {

    productArea =
      document.querySelector(
        '.product-grid-container'
      );

  }


  if (!productArea) {
    return;
  }


  /*
   * Remove an existing loader first.
   */

  var oldLoader =
    document.getElementById(
      'custom-api-page-loader'
    );

  if (oldLoader) {
    oldLoader.remove();
  }


  /*
   * Loader wrapper.
   */

  var loader =
    document.createElement(
      'div'
    );

  loader.id =
    'custom-api-page-loader';

  loader.className =
    'custom-api-page-loader';


  loader.innerHTML = `
    <div class="loader"></div>
    <div class="custom-api-loader-text">
      Loading products...
    </div>
  `;


  /*
   * Make the product area the positioning parent.
   */

  var computedPosition =
    window.getComputedStyle(
      productArea
    ).position;

  if (
    computedPosition === 'static'
  ) {

    productArea.style.position =
      'relative';

  }


  /*
   * Keep the existing product cards visible underneath
   * while the new products are being fetched.
   * The white overlay + spinner makes it obvious that
   * the product area is loading.
   */

  productArea.classList.add(
    'custom-products-loading'
  );


  productArea.appendChild(
    loader
  );


  /*
   * Prevent double clicks while loading.
   */

  var buttons =
    document.querySelectorAll(
      '#custom-api-pagination button'
    );

  buttons.forEach(
    function (button) {

      button.disabled =
        true;

    }
  );


  addCustomPaginationStyles();

}


/*
 * ============================================================
 * HIDE LOADING OVERLAY
 * ============================================================
 */

function hideCustomPageLoading() {

  var loader =
    document.getElementById(
      'custom-api-page-loader'
    );

  if (loader) {

    loader.remove();

  }


  /*
   * Remove the loading state from the product area.
   */

  var productArea =
    document.querySelector(
      '.product-grid-container.shopify_desk .product-grid'
    );

  if (!productArea) {

    productArea =
      document.querySelector(
        '.product-grid-container.shopify_desk'
      );

  }

  if (productArea) {

    productArea.classList.remove(
      'custom-products-loading'
    );

  }


  /*
   * Re-enable pagination buttons after the requested
   * page has finished loading.
   */

  var buttons =
    document.querySelectorAll(
      '#custom-api-pagination button'
    );

  buttons.forEach(
    function (button) {

      /*
       * renderCustomPagination() will apply the correct
       * disabled state to the new pagination. Only enable
       * buttons that are not marked disabled by the current
       * page.
       */

      if (
        button.dataset.customLoaderDisabled ===
        '1'
      ) {

        delete button.dataset.customLoaderDisabled;

      }

    }
  );

}


/*
 * ============================================================
 * SCROLL TO PRODUCT GRID
 * ============================================================
 */

function scrollToCustomProductGrid() {

  var target =
    document.querySelector(
      '.product-grid-container.shopify_desk'
    );


  if (!target) {
    return;
  }


  var rect =
    target.getBoundingClientRect();


  var absoluteTop =
    rect.top +
    window.pageYOffset;


  var offset = 100;


  window.scrollTo({

    top:
      Math.max(
        0,
        absoluteTop - offset
      ),

    behavior:
      'smooth'

  });

}

/*
 * ============================================================
 * PAGINATION CSS
 * ============================================================
 */

function addCustomPaginationStyles() {

  if (
    document.getElementById(
      'custom-api-pagination-styles'
    )
  ) {
    return;
  }


  var style =
    document.createElement(
      'style'
    );


  style.id =
    'custom-api-pagination-styles';


  style.textContent = `

    #custom-api-pagination {

      width: 100%;

      display: flex;

      align-items: center;

      justify-content: center;

      gap: 10px;

      margin: 40px 0 30px;

      padding: 0;

      clear: both;

      flex-wrap: wrap;

    }


    #custom-api-pagination
    button {

      font-family: inherit;

    }


    #custom-api-pagination
    .custom-pagination-arrow {

      width: 40px;

      height: 40px;

      min-width: 40px;

      border: 0;

      border-radius: 6px;

      background: #f5f5f5;

      color: #222;

      font-size: 22px;

      line-height: 40px;

      padding: 0;

      cursor: pointer;

      display: flex;

      align-items: center;

      justify-content: center;

    }


    #custom-api-pagination
    .custom-pagination-arrow:hover:not(:disabled) {

      background: #e9e9e9;

    }


    #custom-api-pagination
    .custom-pagination-arrow:disabled {

      opacity: .35;

      cursor: not-allowed;

    }


    #custom-api-pagination
    .custom-pagination-number {

      width: 40px;

      height: 40px;

      min-width: 40px;

      border: 0;

      border-radius: 6px;

      background: #f5f5f5;

      color: #222;

      font-size: 14px;

      line-height: 40px;

      padding: 0;

      cursor: pointer;

      display: flex;

      align-items: center;

      justify-content: center;

    }


    #custom-api-pagination
    .custom-pagination-number:hover {

      background: #e9e9e9;

    }


    #custom-api-pagination
    .custom-pagination-number.is-active {

      background: #e1e1e1;

      font-weight: 600;

    }


    #custom-api-pagination
    .custom-pagination-dots {

      width: 25px;

      text-align: center;

      font-size: 14px;

      color: #222;

      line-height: 40px;

    }


    /*
     * ----------------------------------------------------------
     * PAGE LOADER
     * ----------------------------------------------------------
     */

    /*
     * ----------------------------------------------------------
     * PAGE LOADER
     * ----------------------------------------------------------
     */

    /*
     * Product grid loading state.
     * Keep the current cards visible underneath the loader.
     */

    .product-grid.custom-products-loading {
      position: relative;
    }


    #custom-api-page-loader {

      position: absolute;

      z-index: 99999;

      inset: 0;

      min-height: 300px;

      width: 100%;

      display: flex;

      align-items: center;

      justify-content: center;

      flex-direction: column;

      gap: 14px;

      background: rgba(255,255,255,.82);

      backdrop-filter: blur(2px);

      pointer-events: all;

    }


    /*
     * Requested loader
     */

    #custom-api-page-loader .loader {

      width: 50px;

      aspect-ratio: 1;

      border-radius: 50%;

      background:

        radial-gradient(
          farthest-side,
          #ffa516 94%,
          #0000
        )
        top/8px 8px
        no-repeat,

        conic-gradient(
          #0000 30%,
          #ffa516
        );

      -webkit-mask:

        radial-gradient(
          farthest-side,
          #0000 calc(100% - 8px),
          #000 0
        );

      mask:

        radial-gradient(
          farthest-side,
          #0000 calc(100% - 8px),
          #000 0
        );

      animation:
        customApiLoaderSpin
        1s infinite linear;

    }


    @keyframes customApiLoaderSpin {

      100% {

        transform:
          rotate(1turn);

      }

    }


    #custom-api-page-loader
    .custom-api-loader-text {

      font-size: 14px;

      font-weight: 500;

      line-height: 1.4;

      color: #222;

    }


    @media screen and (max-width: 575px) {

      #custom-api-pagination {

        gap: 6px;

        margin-top: 30px;

      }


      #custom-api-pagination
      .custom-pagination-arrow,

      #custom-api-pagination
      .custom-pagination-number {

        width: 36px;

        height: 36px;

        min-width: 36px;

        line-height: 36px;

      }


      #custom-api-pagination
      .custom-pagination-dots {

        width: 18px;

        line-height: 36px;

      }

    }

  `;


  document.head.appendChild(
    style
  );

}



  /*
   * ============================================================
   * SEND PRODUCTS TO RENDERER
   * ============================================================
   */

  function notifyProductRenderer(
    products,
    collection,
    pageInfo,
    filters
  ) {

    /*
     * Make sure original Zellis
     * is captured before renderer modifies it.
     */

    saveOriginalZellisProducts();

    document.dispatchEvent(
      new CustomEvent(
        'custom:large-collection-products-ready',
        {
          detail: {

            products:
              products,

            collection:
              collection,

            pageInfo:
              pageInfo,

            filters:
              filters
          }
        }
      )
    );
  }

  /*
   * ============================================================
   * RESTORE ORIGINAL COLLECTION
   * ============================================================
   */

  function restoreOriginalCollection() {

    console.log(
      'CUSTOM FILTER: RESTORING ORIGINAL COLLECTION'
    );

    showStatus(
      'Loading products...'
    );

    /*
     * ==========================================================
     * IMPORTANT
     *
     * First directly restore our backup.
     *
     * This means even if renderer clears #zellis-view,
     * the original products are available again.
     * ==========================================================
     */

    restoreOriginalZellisFallback();

    /*
     * Notify renderer.
     *
     * Existing renderer can perform its own cleanup.
     */

    document.dispatchEvent(
      new CustomEvent(
        'custom:large-collection-filter-cleared'
      )
    );

    /*
     * DO NOT depend only on this event.
     *
     * Some renderer versions clear #zellis-view
     * after receiving reset.
     */

    document.dispatchEvent(
      new CustomEvent(
        'custom:large-collection-products-reset'
      )
    );

    /*
     * Restore again after renderer handlers finish.
     */

    setTimeout(
      function () {

        restoreOriginalZellisFallback();

        showStatus('');

      },
      250
    );

    /*
     * Extra safety restore.
     */

    setTimeout(
      function () {

        restoreOriginalZellisFallback();

      },
      600
    );
  }

  /*
   * ============================================================
   * SELECTED FILTERS -> URL
   * ============================================================
   */

  function selectedInputsToURL() {

    var selected =
      getSelectedFilters();

    return selected.map(
      function (
        item
      ) {

        return {

          filterId:
            item.filterId,

          input:
            item.input,

          valueId:
            item.valueId
        };
      }
    );
  }

  /*
   * ============================================================
   * UPDATE URL
   * ============================================================
   */

  function updateURL(
    selected
  ) {

    var url =
      new URL(
        window.location.href
      );

    /*
     * Remove old custom filter.
     */

    url.searchParams.delete(
      'custom_filter'
    );

    /*
     * Add selected filter.
     */

    if (
      selected &&
      selected.length
    ) {

      try {

        var encoded =
          btoa(
            unescape(
              encodeURIComponent(
                JSON.stringify(
                  selected
                )
              )
            )
          );

        url.searchParams.set(
          'custom_filter',
          encoded
        );

      } catch (
        error
      ) {

        console.error(
          'UNABLE TO ENCODE FILTER URL:',
          error
        );
      }
    }

    /*
     * Reset page.
     */

    url.searchParams.delete(
      'page'
    );

    /*
     * Update browser URL.
     */

    window.history.pushState(
      {},
      '',
      url.toString()
    );
  }

  /*
   * ============================================================
   * CLEAR BUTTON
   * ============================================================
   */

  if (clearButton) {

    clearButton.addEventListener(
      'click',
      function () {

        console.log(
          'CUSTOM FILTER: CLEAR BUTTON CLICKED'
        );

        /*
         * Uncheck everything.
         */

        var checkboxes =
          groupsContainer.querySelectorAll(
            'input[type="checkbox"]'
          );

        checkboxes.forEach(
          function (
            checkbox
          ) {

            checkbox.checked =
              false;
          }
        );

        /*
         * Update button.
         */

        updateClearButton();

        /*
         * Cancel pending request.
         */

        currentRequestId++;

        lastFilteredProducts =
          [];

        lastFilteredPageInfo =
          null;


        currentFilteredApiFilters = [];

currentFilteredPage = 1;

currentFilteredTotalCount = 0;

filteredPageCursors = {
  1: null
};

var pagination =
  document.getElementById(
    'custom-api-pagination'
  );

if (pagination) {
  pagination.remove();
}
        /*
         * Remove filter from URL.
         */

        updateURL([]);

var currentUrl = new URL(window.location.href);

if (!currentUrl.searchParams.has('custom_filter')) {
  window.location.reload();
  return;
}
      }
    );
  }

  /*
   * ============================================================
   * CLEAR BUTTON STATE
   * ============================================================
   */

  function updateClearButton() {

  if (clearButton) {

    var selected =
      groupsContainer.querySelectorAll(
        'input[type="checkbox"]:checked'
      );

    clearButton.hidden =
      selected.length === 0;
  }

  /*
   * Also update selected filter chips.
   */

  renderSelectedFilters();
}

  /*
 * ============================================================
 * RENDER SELECTED FILTERS
 * ============================================================
 */

function renderSelectedFilters() {

  var box =
    createSelectedFiltersContainer();

  if (!box) {
    return;
  }

  var selected =
    getSelectedFilters();

  box.innerHTML = '';

  /*
   * No selected filters
   */

  if (!selected.length) {

    box.style.display = 'none';

    return;
  }

  box.style.display = 'block';

  

  /*
   * Selected filter chips
   */

  selected.forEach(
    function (
      selectedFilter
    ) {

      var chip =
        document.createElement('div');

      chip.className =
        'custom-selected-filter-chip';

      /*
       * Find original checkbox
       */

      var checkbox =
        groupsContainer.querySelector(
          'input[type="checkbox"][data-value-id="' +
          CSS.escape(
            selectedFilter.valueId
          ) +
          '"]'
        );

      var filterLabel = '';

      if (checkbox) {

        var option =
          checkbox.closest(
            '.custom-filter-option'
          );

        if (option) {

          var label =
            option.querySelector(
              '.custom-filter-option-label'
            );

          if (label) {

            filterLabel =
              label.textContent.trim();

          }
        }
      }

      /*
       * Find filter group label
       */

      var group =
        checkbox
          ? checkbox.closest(
              '.custom-filter-group'
            )
          : null;

      var groupTitle = '';

      if (group) {

        var groupTitleElement =
          group.querySelector(
            '.custom-filter-group-title'
          );

        if (groupTitleElement) {

          groupTitle =
            groupTitleElement.textContent.trim();

        }
      }

      /*
       * Chip text
       */

      var text =
        document.createElement('span');

      text.className =
        'custom-selected-filter-text';

      if (
        groupTitle &&
        filterLabel
      ) {

        text.textContent =
          groupTitle +
          ': ' +
          filterLabel;

      } else {

        text.textContent =
          filterLabel ||
          selectedFilter.valueId ||
          'Selected filter';
      }

      /*
       * Remove button
       */

      var remove =
        document.createElement('button');

      remove.type =
        'button';

      remove.className =
        'custom-selected-filter-remove';

      remove.setAttribute(
        'aria-label',
        'Remove ' +
        (
          filterLabel ||
          selectedFilter.valueId
        )
      );

      remove.innerHTML =
        '&times;';

      /*
       * Remove selected filter
       */

      remove.addEventListener(
        'click',
        function () {

          /*
           * Find checkbox again.
           */

          var targetCheckbox =
            groupsContainer.querySelector(
              'input[type="checkbox"][data-value-id="' +
              CSS.escape(
                selectedFilter.valueId
              ) +
              '"]'
            );

          if (
            targetCheckbox &&
            targetCheckbox.checked
          ) {

            targetCheckbox.checked =
              false;
          }

          /*
           * Apply remaining filters.
           */

          applyFilters();

        }
      );

      chip.appendChild(
        text
      );

      chip.appendChild(
        remove
      );

      box.appendChild(
        chip
      );
    }
  );
}

  /*
   * ============================================================
   * LOADING
   * ============================================================
   */

  function showLoading() {

    groupsContainer.innerHTML =
      '<div class="custom-filter-loading">' +
      'Loading filters...' +
      '</div>';
  }

  /*
   * ============================================================
   * STATUS
   * ============================================================
   */

 function showStatus(
  message
) {

  if (!statusElement) {
    return;
  }

  statusElement.textContent =
    message || '';

  /*
   * Use custom-filter-status as the
   * source for filtered product count.
   */

  syncProductCountFromCustomStatus();

}

  /*
 * ============================================================
 * SYNC SHOPIFY PRODUCT COUNT FROM CUSTOM FILTER STATUS
 * ============================================================
 *
 * Example:
 *
 * custom-filter-status:
 * "Showing 230 filtered products"
 *
 * ProductCountDesktop:
 * "230 of 8994 products"
 *
 * ============================================================
 */

function syncProductCountFromCustomStatus() {

  var statusElement =
    document.getElementById(
      'custom-filter-status'
    );


  if (!statusElement) {
    return;
  }


  var statusText =
    (
      statusElement.textContent ||
      ''
    ).trim();


  /*
   * Only process filtered status.
   */

  var match =
    statusText.match(
      /Showing\s+([\d,]+)\s+filtered\s+products/i
    );


  if (!match) {
    return;
  }


  /*
   * Get filtered product count.
   */

  var filteredCount =
    Number(
      match[1].replace(
        /,/g,
        ''
      )
    );


  if (
    !Number.isFinite(
      filteredCount
    )
  ) {
    return;
  }


  /* Use the same canonical collection count everywhere. */
  var originalCount =
    getCanonicalCollectionProductCount();


  /*
   * Format numbers.
   */

  var filteredText =
    filteredCount.toLocaleString(
      'en-AU'
    );


  var originalText =
    originalCount.toLocaleString(
      'en-AU'
    );


  var finalText =
    filteredText +
    ' of ' +
    originalText +
    ' products';


  /*
   * ----------------------------------------------------------
   * UPDATE DESKTOP COUNT
   * ----------------------------------------------------------
   */

  var desktopCount =
    document.getElementById(
      'ProductCountDesktop'
    );


  if (desktopCount) {

    desktopCount.textContent =
      finalText;

  }


  /*
   * ----------------------------------------------------------
   * UPDATE MOBILE COUNT
   * ----------------------------------------------------------
   */

  var mobileCount =
    document.getElementById(
      'ProductCountMobile'
    );


  if (mobileCount) {

    mobileCount.textContent =
      finalText;

  }


  /*
   * ----------------------------------------------------------
   * UPDATE OUR MOBILE TOOLBAR COUNT
   * ----------------------------------------------------------
   */

  var toolbarCount =
    document.getElementById(
      'custom-mobile-filter-toolbar-count'
    );


  if (toolbarCount) {

    toolbarCount.textContent =
      finalText;

  }


  /*
   * ----------------------------------------------------------
   * UPDATE MOBILE DRAWER COUNT
   * ----------------------------------------------------------
   */

  var drawerCount =
    document.getElementById(
      'custom-mobile-filter-count'
    );


  if (drawerCount) {

    drawerCount.textContent =
      finalText;

  }


  console.log(
    'CUSTOM FILTER: PRODUCT COUNT SYNCED FROM STATUS:',
    finalText
  );

}

  /*
   * ============================================================
   * ERROR
   * ============================================================
   */

  function showError(
    message
  ) {

    groupsContainer.innerHTML =
      '<div class="custom-filter-error">' +
      escapeHtml(
        message
      ) +
      '</div>';

    if (statusElement) {

      statusElement.textContent =
        '';
    }
  }

  /*
   * ============================================================
   * PRODUCT GRID LOADING
   * ============================================================
   */
  

  function hideProductGridLoading() {

    var loaders =
      document.querySelectorAll(
        '#ProductGridContainer .loading-overlay'
      );

    loaders.forEach(
      function (
        loader
      ) {

        loader.classList.remove(
          'is-visible'
        );
      }
    );
  }

  /*
   * ============================================================
   * ESCAPE HTML
   * ============================================================
   */

  function escapeHtml(
    value
  ) {

    if (
      value === null ||
      value === undefined
    ) {

      return '';
    }

    return String(value)

      .replace(
        /&/g,
        '&amp;'
      )

      .replace(
        /</g,
        '&lt;'
      )

      .replace(
        />/g,
        '&gt;'
      )

      .replace(
        /"/g,
        '&quot;'
      )

      .replace(
        /'/g,
        '&#039;'
      );
  }

  /*
   * ============================================================
   * START
   * ============================================================
   */

  /*
   * Start capturing original Zellis.
   */

  startOriginalZellisCapture();


  /* ============================================================
 * MOBILE FILTER + SORT DRAWER
 * ============================================================ */

function initMobileFilterDrawer() {


  if (
    window.innerWidth >= 992
  ) {
    return;
  }

  var container =
    document.getElementById(
      'custom-large-collection-filters'
    );

  if (!container) {
    return;
  }

  /*
   * Don't create twice.
   */
  if (
    document.getElementById(
      'custom-mobile-filter-drawer'
    )
  ) {
    return;
  }

  /*
   * ----------------------------------------------------------
   * GET PRODUCT COUNT
   * ----------------------------------------------------------
   */

  var productCount =
    document.getElementById(
      'ProductCountDesktop'
    );

  var countText =
    productCount
      ? productCount.textContent.trim()
      : '';

  /*
   * ----------------------------------------------------------
   * CREATE MOBILE DRAWER
   * ----------------------------------------------------------
   */

  var drawer =
    document.createElement('div');

  drawer.id =
    'custom-mobile-filter-drawer';

  drawer.className =
    'custom-mobile-filter-drawer';

  /*
   * ----------------------------------------------------------
   * HEADER
   * ----------------------------------------------------------
   */

  var header =
    document.createElement('div');

  header.className =
    'custom-mobile-filter-header';

  header.innerHTML =
    '<h2 class="custom-mobile-filter-title">' +
      'Filter and sort' +
    '</h2>' +

    '<div ' +
      'class="custom-mobile-filter-count" ' +
      'id="custom-mobile-filter-count">' +
      countText +
    '</div>' +

    '<button ' +
      'type="button" ' +
      'class="custom-mobile-filter-close" ' +
      'aria-label="Close filter and sort">' +
      '&times;' +
    '</button>';

  /*
   * ----------------------------------------------------------
   * CONTENT
   * ----------------------------------------------------------
   */

  var content =
    document.createElement('div');

  content.className =
    'custom-mobile-filter-content';

  /*
   * MAIN MENU
   */

  var menu =
    document.createElement('div');

  menu.className =
    'custom-mobile-filter-menu';

  /*
   * DETAIL CONTAINER
   */

  var detail =
    document.createElement('div');

  detail.className =
    'custom-mobile-filter-detail';

  /*
   * ----------------------------------------------------------
   * FILTER GROUPS
   * ----------------------------------------------------------
   */

  var sourceGroups =
    document.getElementById(
      'custom-filter-groups'
    );

  /*
   * Build menu from existing filter groups.
   */
function buildMobileGroups() {

  menu.innerHTML = '';
  detail.innerHTML = '';

  if (!sourceGroups) {
    return;
  }

  /*
   * Get original desktop filter groups.
   */
  var groups =
    sourceGroups.querySelectorAll(
      '.custom-filter-group'
    );

  if (!groups.length) {
    groups = sourceGroups.children;
  }

  Array.from(groups).forEach(
    function (group, index) {

      /*
       * ------------------------------------------------------
       * FILTER TITLE
       * ------------------------------------------------------
       */

      var titleElement =
        group.querySelector(
          '.custom-filter-group-title'
        ) ||
        group.querySelector(
          '.custom-filter-title'
        ) ||
        group.querySelector('h3') ||
        group.querySelector('h4');

      var title =
        titleElement
          ? titleElement.textContent.trim()
          : 'Filter ' + (index + 1);


      /*
       * ------------------------------------------------------
       * MOBILE MENU ITEM
       * ------------------------------------------------------
       */

      var menuItem =
        document.createElement('button');

      menuItem.type = 'button';

      menuItem.className =
        'custom-mobile-filter-menu-item';

      menuItem.style.display =
        'flex';

      menuItem.style.width =
        '100%';

      menuItem.style.alignItems =
        'center';

      menuItem.style.justifyContent =
        'space-between';

      menuItem.style.padding =
        '14px 12px';

      menuItem.style.marginBottom =
        '12px';

      menuItem.style.border =
        '0';

      menuItem.style.borderRadius =
        '6px';

      menuItem.style.background =
        '#f6f6f6';

      menuItem.style.color =
        '#222';

      menuItem.style.fontSize =
        '14px';

      menuItem.style.fontWeight =
        '500';

      menuItem.style.textAlign =
        'left';

      menuItem.style.cursor =
        'pointer';

      menuItem.innerHTML =
        '<span>' +
          escapeHtml(title) +
        '</span>' +

        '<span ' +
          'class="custom-mobile-filter-arrow">' +
          '&rsaquo;' +
        '</span>';


      /*
       * ------------------------------------------------------
       * DETAIL PAGE
       * ------------------------------------------------------
       */

      var detailItem =
        document.createElement('div');

      detailItem.className =
        'custom-mobile-filter-detail';

      /*
       * IMPORTANT
       * Force hidden initially.
       */
      detailItem.style.display =
        'none';

      detailItem.style.width =
        '100%';

      detailItem.style.height =
        '100%';

      detailItem.style.overflowY =
        'auto';

      detailItem.style.background =
        '#ffffff';

      detailItem.style.color =
        '#222222';

      detailItem.style.boxSizing =
        'border-box';

      detailItem.style.padding =
        '15px';


      /*
       * ------------------------------------------------------
       * BACK BUTTON
       * ------------------------------------------------------
       */

      var backButton =
        document.createElement('button');

      backButton.type =
        'button';

      backButton.className =
        'custom-mobile-filter-back';

      backButton.style.display =
        'flex';

      backButton.style.alignItems =
        'center';

      backButton.style.gap =
        '8px';

      backButton.style.width =
        '100%';

      backButton.style.padding =
        '12px 0';

      backButton.style.margin =
        '0 0 15px';

      backButton.style.border =
        '0';

      backButton.style.borderBottom =
        '1px solid #eeeeee';

      backButton.style.background =
        '#ffffff';

      backButton.style.color =
        '#222222';

      backButton.style.fontSize =
        '15px';

      backButton.style.fontWeight =
        '600';

      backButton.style.textAlign =
        'left';

      backButton.style.cursor =
        'pointer';

      backButton.innerHTML =
        '<span ' +
          'class="custom-mobile-filter-back-icon">' +
          '&lsaquo;' +
        '</span>' +

        '<span>' +
          escapeHtml(title) +
        '</span>';


/*
 * ------------------------------------------------------
 * CLONE COMPLETE FILTER GROUP
 * ------------------------------------------------------
 *
 * IMPORTANT:
 * The original group already contains:
 *
 * - Search
 * - Checkbox
 * - Brand value
 * - Category value
 * - Count
 * - data-filter-input
 * - data-value-id
 *
 * So clone the complete group.
 */

var clonedGroup =
  group.cloneNode(true);


/*
 * Remove desktop accordion header.
 */

var clonedHeader =
  clonedGroup.querySelector(
    '.custom-filter-group-header'
  );

if (clonedHeader) {
  clonedHeader.remove();
}


/*
 * Remove desktop group title if present.
 */

var clonedTitle =
  clonedGroup.querySelector(
    '.custom-filter-group-title'
  );

if (clonedTitle) {
  clonedTitle.remove();
}


/*
 * Remove accordion state.
 */

clonedGroup.classList.remove(
  'is-open'
);


/*
 * Force group visible.
 */

clonedGroup.style.display =
  'block';

clonedGroup.style.width =
  '100%';

clonedGroup.style.height =
  'auto';

clonedGroup.style.maxHeight =
  'none';

clonedGroup.style.overflow =
  'visible';

clonedGroup.style.visibility =
  'visible';

clonedGroup.style.opacity =
  '1';

clonedGroup.style.background =
  '#ffffff';

clonedGroup.style.color =
  '#222222';

clonedGroup.style.boxSizing =
  'border-box';


/*
 * ------------------------------------------------------
 * FILTER CONTENT
 * ------------------------------------------------------
 */

var mobileContent =
  clonedGroup.querySelector(
    '.custom-filter-group-content'
  );

if (mobileContent) {

  mobileContent.style.display =
    'block';

  mobileContent.style.visibility =
    'visible';

  mobileContent.style.opacity =
    '1';

  mobileContent.style.position =
    'static';

  mobileContent.style.width =
    '100%';

  mobileContent.style.height =
    'auto';

  mobileContent.style.maxHeight =
    'none';

  mobileContent.style.minHeight =
    '0';

  mobileContent.style.overflow =
    'visible';

  mobileContent.style.background =
    '#ffffff';

  mobileContent.style.color =
    '#222222';

  mobileContent.style.padding =
    '0';

  mobileContent.style.margin =
    '0';

}


/*
 * ------------------------------------------------------
 * FILTER VALUES
 * ------------------------------------------------------
 */

var mobileValues =
  clonedGroup.querySelector(
    '.custom-filter-values'
  );

if (mobileValues) {

  mobileValues.style.display =
    'flex';

  mobileValues.style.flexDirection =
    'column';

  mobileValues.style.width =
    '100%';

  mobileValues.style.height =
    'auto';

  mobileValues.style.maxHeight =
    'none';

  mobileValues.style.overflow =
    'visible';

  mobileValues.style.visibility =
    'visible';

  mobileValues.style.opacity =
    '1';

}


/*
 * ------------------------------------------------------
 * FILTER OPTIONS
 * ------------------------------------------------------
 */

var mobileOptions =
  clonedGroup.querySelectorAll(
    '.custom-filter-option'
  );

mobileOptions.forEach(
  function (option) {

    option.style.display =
      'flex';

    option.style.alignItems =
      'center';

    option.style.width =
      '100%';

    option.style.minHeight =
      '46px';

    option.style.padding =
      '10px 2px';

    option.style.margin =
      '0';

    option.style.background =
      '#ffffff';

    option.style.color =
      '#222222';

    option.style.borderBottom =
      '1px solid #eeeeee';

    option.style.boxSizing =
      'border-box';

  }
);


/*
 * ------------------------------------------------------
 * CHECKBOXES
 * ------------------------------------------------------
 */

var mobileCheckboxes =
  clonedGroup.querySelectorAll(
    'input[type="checkbox"]'
  );

mobileCheckboxes.forEach(
  function (checkbox) {

    checkbox.style.display =
      'inline-block';

    checkbox.style.visibility =
      'visible';

    checkbox.style.opacity =
      '1';

    checkbox.style.width =
      '18px';

    checkbox.style.height =
      '18px';

    checkbox.style.minWidth =
      '18px';

    checkbox.style.marginRight =
      '10px';

  }
);


/*
 * ------------------------------------------------------
 * LABELS
 * ------------------------------------------------------
 */

var mobileLabels =
  clonedGroup.querySelectorAll(
    '.custom-filter-option-label'
  );

mobileLabels.forEach(
  function (label) {

    label.style.display =
      'inline-block';

    label.style.visibility =
      'visible';

    label.style.opacity =
      '1';

    label.style.color =
      '#222222';

  }
);


/*
 * ------------------------------------------------------
 * COUNTS
 * ------------------------------------------------------
 */

var mobileCounts =
  clonedGroup.querySelectorAll(
    '.custom-filter-option-count'
  );

mobileCounts.forEach(
  function (count) {

    count.style.display =
      'inline-block';

    count.style.visibility =
      'visible';

    count.style.opacity =
      '1';

    count.style.color =
      '#777777';

    count.style.marginLeft =
      'auto';

  }
);


/*
 * ------------------------------------------------------
 * APPEND DETAIL
 * ------------------------------------------------------
 */

detailItem.appendChild(
  backButton
);

detailItem.appendChild(
  clonedGroup
);

      /*
       * ------------------------------------------------------
       * MENU CLICK
       * ------------------------------------------------------
       */

      menuItem.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          /*
           * Hide main menu.
           */
          menu.style.display =
            'none';

          /*
           * Hide all detail pages.
           */
          detail
            .querySelectorAll(
              '.custom-mobile-filter-detail'
            )
            .forEach(
              function (item) {

                item.classList.remove(
                  'active'
                );

                /*
                 * IMPORTANT:
                 * Inline display overrides
                 * desktop/theme CSS.
                 */
                item.style.display =
                  'none';

              }
            );

          /*
           * Show selected detail page.
           */
          detailItem.classList.add(
            'active'
          );

          detailItem.style.display =
            'block';

          detailItem.style.visibility =
            'visible';

          detailItem.style.opacity =
            '1';

        }
      );


      /*
       * ------------------------------------------------------
       * BACK CLICK
       * ------------------------------------------------------
       */

      backButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          detailItem.classList.remove(
            'active'
          );

          detailItem.style.display =
            'none';

          menu.style.display =
            'block';

        }
      );


      /*
       * ------------------------------------------------------
       * APPEND
       * ------------------------------------------------------
       */

      menu.appendChild(
        menuItem
      );

      detail.appendChild(
        detailItem
      );

    }
  );

}

  /*
   * ----------------------------------------------------------
   * SORT MENU
   * ----------------------------------------------------------
   */

  var sortItem =
    document.createElement('div');

  sortItem.className =
    'custom-mobile-filter-menu-item';

  sortItem.innerHTML =
    '<span>Sort by:</span>' +

    '<span>' +
      '<span id="custom-mobile-sort-value">' +
        'Best selling' +
      '</span>' +

      ' &rsaquo;' +
    '</span>';

  var sortDetail =
    document.createElement('div');

  sortDetail.className =
    'custom-mobile-filter-detail';

  var sortBack =
    document.createElement('button');

  sortBack.type =
    'button';

  sortBack.className =
    'custom-mobile-filter-back';

  sortBack.innerHTML =
    '<span class="custom-mobile-filter-back-icon">' +
      '&lsaquo;' +
    '</span>' +

    '<span>Sort by:</span>';

  sortDetail.appendChild(
    sortBack
  );

  /*
   * Shopify existing sort select.
   */
  var existingSort =
    document.querySelector(
      '#SortBy'
    ) ||
    document.querySelector(
      'select[name="sort_by"]'
    );

  if (existingSort) {

    bindCustomSortPreservation();

    Array.from(
      existingSort.options
    ).forEach(
      function (option) {

        var label =
          document.createElement(
            'label'
          );

        label.innerHTML =
          '<input ' +
            'type="radio" ' +
            'name="custom-mobile-sort" ' +
            'value="' +
              escapeHtml(
                option.value
              ) +
            '">' +

          '<span>' +
            escapeHtml(
              option.textContent
            ) +
          '</span>';

        var radio =
          label.querySelector(
            'input'
          );

        radio.addEventListener(
          'change',
          function () {

            /*
             * Update existing Shopify sort.
             */
            existingSort.value =
              option.value;

            existingSort.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );

            var valueElement =
              document.getElementById(
                'custom-mobile-sort-value'
              );

            if (valueElement) {

              valueElement.textContent =
                option.textContent.trim();

            }

            sortDetail.classList.remove(
              'active'
            );

            menu.style.display =
              'block';

          }
        );

        sortDetail.appendChild(
          label
        );

      }
    );

  }

  sortItem.addEventListener(
    'click',
    function () {

      menu.style.display =
        'none';

      detail
        .querySelectorAll(
          '.custom-mobile-filter-detail'
        )
        .forEach(
          function (item) {
            item.classList.remove(
              'active'
            );
          }
        );

      sortDetail.classList.add(
        'active'
      );

    }
  );

  sortBack.addEventListener(
    'click',
    function () {

      sortDetail.classList.remove(
        'active'
      );

      menu.style.display =
        'block';

    }
  );

  /*
   * ----------------------------------------------------------
   * FOOTER
   * ----------------------------------------------------------
   */

  var footer =
    document.createElement('div');

  footer.className =
    'custom-mobile-filter-footer';

  var clear =
    document.createElement('button');

  clear.type =
    'button';

  clear.className =
    'custom-mobile-filter-clear';

  clear.textContent =
    'Remove all';

  var apply =
    document.createElement('button');

  apply.type =
    'button';

  apply.className =
    'custom-mobile-filter-apply';

  apply.textContent =
    'Apply';

  /*
   * CLEAR
   */
  clear.addEventListener(
    'click',
    function () {

      if (window.CustomLargeCollectionFilter) {

        var existingClear =
          document.getElementById(
            'custom-filter-clear'
          );

        if (existingClear) {
          existingClear.click();
        }

      }

      closeMobileFilterDrawer();

    }
  );

  /*
   * APPLY
   */
  apply.addEventListener(
    'click',
    function () {

      /*
       * Copy mobile checkbox state back
       * to original filter checkboxes.
       */
      syncMobileFiltersToDesktop();

      /*
       * Apply existing API filter logic.
       */
      if (
        window.CustomLargeCollectionFilter
      ) {

        window.CustomLargeCollectionFilter
          .applyFilters();

      }

      closeMobileFilterDrawer();

    }
  );

  footer.appendChild(
    clear
  );

  footer.appendChild(
    apply
  );

  /*
   * ----------------------------------------------------------
   * BUILD
   * ----------------------------------------------------------
   */

  buildMobileGroups();

  menu.appendChild(
    sortItem
  );

  detail.appendChild(
    sortDetail
  );

  content.appendChild(
    menu
  );

  content.appendChild(
    detail
  );

  drawer.appendChild(
    header
  );

  drawer.appendChild(
    content
  );

  drawer.appendChild(
    footer
  );

  container.appendChild(
    drawer
  );

  /*
   * ----------------------------------------------------------
   * CLOSE
   * ----------------------------------------------------------
   */

  header
    .querySelector(
      '.custom-mobile-filter-close'
    )
    .addEventListener(
      'click',
      closeMobileFilterDrawer
    );

}

/*
 * ============================================================
 * SYNC MOBILE FILTERS
 * ============================================================
 */

function syncMobileFiltersToDesktop() {

  var sourceGroups =
    document.getElementById(
      'custom-filter-groups'
    );

  var drawer =
    document.getElementById(
      'custom-mobile-filter-drawer'
    );

  if (
    !sourceGroups ||
    !drawer
  ) {
    return;
  }

  /*
   * Get original checkboxes.
   */
  var originalCheckboxes =
    sourceGroups.querySelectorAll(
      'input[type="checkbox"]'
    );

  /*
   * Get mobile checkboxes.
   */
  var mobileCheckboxes =
    drawer.querySelectorAll(
      'input[type="checkbox"]'
    );

  /*
   * Match by data-value-id.
   */
  mobileCheckboxes.forEach(
    function (
      mobileCheckbox
    ) {

      var valueId =
        mobileCheckbox.getAttribute(
          'data-value-id'
        );

      if (!valueId) {
        return;
      }

      var original =
        sourceGroups.querySelector(
          'input[type="checkbox"][data-value-id="' +
            CSS.escape(valueId) +
          '"]'
        );

      if (!original) {
        return;
      }

      original.checked =
        mobileCheckbox.checked;

    }
  );

}


/*
 * ============================================================
 * OPEN DRAWER
 * ============================================================
 */

function openMobileFilterDrawer() {

  var container =
    document.getElementById(
      'custom-large-collection-filters'
    );

  if (!container) {
    return;
  }

  var desktopGroups =
  document.getElementById(
    'custom-filter-groups'
  );

if (desktopGroups) {

  desktopGroups.style.display =
    'none';

}

  initMobileFilterDrawer();

  container.classList.add(
    'mobile-filter-open'
  );

  document.body.classList.add(
    'custom-mobile-filter-active'
  );

}


/*
 * ============================================================
 * CLOSE DRAWER
 * ============================================================
 */

function closeMobileFilterDrawer() {

  var container =
    document.getElementById(
      'custom-large-collection-filters'
    );

  if (!container) {
    return;
  }

  container.classList.remove(
    'mobile-filter-open'
  );

  document.body.classList.remove(
    'custom-mobile-filter-active'
  );

}


/*
 * ============================================================
 * MOBILE FILTER OPEN BUTTON
 * ============================================================
 */


/*
 * ============================================================
 * MOVE SELECTED FILTERS TO MOBILE SHOPIFY TOOLBAR
 * ============================================================
 */

function moveSelectedFiltersToToolbar() {

  if (window.innerWidth >= 992) {
    return;
  }

  var shopifyGrid =
    document.querySelector(
      '.product-grid-container.shopify_desk'
    );

  if (!shopifyGrid) {
    return;
  }

  var selectedFilters =
    document.getElementById(
      'custom-selected-filters'
    );

  if (!selectedFilters) {
    return;
  }

  var toolbar =
    document.getElementById(
      'custom-mobile-filter-toolbar'
    );

  if (!toolbar) {
    return;
  }

  /*
   * Move selected filter chips below
   * Filter and sort toolbar.
   */

  toolbar.insertAdjacentElement(
    'afterend',
    selectedFilters
  );

  selectedFilters.setAttribute(
    'data-mobile-toolbar',
    'true'
  );

}


/*
 * ============================================================
 * UPDATE MOBILE TOOLBAR PRODUCT COUNT
 * ============================================================
 */

function updateMobileToolbarCount() {

  if (window.innerWidth >= 992) {
    return;
  }

  var toolbarCount =
    document.getElementById(
      'custom-mobile-filter-toolbar-count'
    );

  if (!toolbarCount) {
    return;
  }

  var productCount =
    document.getElementById(
      'ProductCountDesktop'
    );

  if (!productCount) {
    return;
  }

  var text =
    (
      productCount.textContent ||
      ''
    ).trim();

  if (text) {
    toolbarCount.textContent =
      text;
  }

}

function initMobileFilterButton() {

  if (window.innerWidth >= 992) {
    return;
  }


  /*
   * ----------------------------------------------------------
   * FIND SHOPIFY PRODUCT AREA
   * ----------------------------------------------------------
   */

  var shopifyGrid =
    document.querySelector(
      '.product-grid-container.shopify_desk'
    );


  if (!shopifyGrid) {

    console.warn(
      'CUSTOM FILTER: Shopify product grid not found.'
    );

    return;

  }


  /*
   * ----------------------------------------------------------
   * DO NOT CREATE TWICE
   * ----------------------------------------------------------
   */

  var existingToolbar =
    document.getElementById(
      'custom-mobile-filter-toolbar'
    );


  if (existingToolbar) {

    moveSelectedFiltersToToolbar();

    updateMobileToolbarCount();

    return;

  }


  /*
   * ----------------------------------------------------------
   * CREATE TOOLBAR
   * ----------------------------------------------------------
   */

  var toolbar =
    document.createElement('div');


  toolbar.id =
    'custom-mobile-filter-toolbar';


  toolbar.className =
    'custom-mobile-filter-toolbar';


  /*
   * ----------------------------------------------------------
   * CREATE FILTER BUTTON
   * ----------------------------------------------------------
   */

  var button =
    document.createElement('button');


  button.type =
    'button';


  button.id =
    'custom-mobile-filter-trigger';


  button.className =
    'custom-mobile-filter-trigger';


  button.setAttribute(
    'aria-label',
    'Filter and sort'
  );


  button.innerHTML =
    '<span class="custom-mobile-filter-trigger-icon">' +
      '☷' +
    '</span>' +
    '<span>Filter and sort</span>';


  /*
   * ----------------------------------------------------------
   * CREATE COUNT
   * ----------------------------------------------------------
   */

  var count =
    document.createElement('div');


  count.id =
    'custom-mobile-filter-toolbar-count';


  count.className =
    'custom-mobile-filter-toolbar-count';


  /*
   * Get existing Shopify count.
   */

  var productCount =
    document.getElementById(
      'ProductCountDesktop'
    );


  var countText =
    productCount
      ? productCount.textContent.trim()
      : '';


  count.textContent =
    countText;


  /*
   * ----------------------------------------------------------
   * APPEND BUTTON + COUNT
   * ----------------------------------------------------------
   */

  toolbar.appendChild(
    button
  );


  toolbar.appendChild(
    count
  );


  /*
   * ----------------------------------------------------------
   * INSERT TOOLBAR AT TOP OF SHOPIFY GRID
   * ----------------------------------------------------------
   */

  shopifyGrid.insertBefore(
    toolbar,
    shopifyGrid.firstChild
  );


  /*
   * ----------------------------------------------------------
   * MOVE SELECTED FILTERS
   * ----------------------------------------------------------
   */

  moveSelectedFiltersToToolbar();


  /*
   * ----------------------------------------------------------
   * UPDATE COUNT
   * ----------------------------------------------------------
   */

  updateMobileToolbarCount();


  /*
   * ----------------------------------------------------------
   * OPEN DRAWER
   * ----------------------------------------------------------
   */

  button.addEventListener(
    'click',
    function (event) {

      event.preventDefault();

      event.stopPropagation();

      openMobileFilterDrawer();

    }
  );


  console.log(
    'CUSTOM FILTER: MOBILE TOOLBAR CREATED'
  );

}

/*
 * ============================================================
 * INITIALIZE MOBILE UI
 * ============================================================
 */

function initializeCustomMobileFilter() {

  if (
    window.innerWidth >= 992
  ) {
    return;
  }

  /*
   * Do NOT create the drawer immediately.
   *
   * renderFilters() must first create:
   *
   * #custom-filter-groups
   *
   * with actual filter groups.
   */

  setTimeout(
    function () {

      var groups =
        document.getElementById(
          'custom-filter-groups'
        );

      if (!groups) {
        return;
      }

      /*
       * If drawer already exists,
       * don't create another one.
       */
      var existingDrawer =
        document.getElementById(
          'custom-mobile-filter-drawer'
        );

      if (
        existingDrawer
      ) {
        return;
      }

      /*
       * Only create when filter groups
       * actually exist.
       */
      var filterGroups =
        groups.querySelectorAll(
          '.custom-filter-group'
        );

      if (
        !filterGroups.length
      ) {
        return;
      }

      initMobileFilterDrawer();

      initMobileFilterButton();

    },
    300
  );

}

  /*
   * Load API filters.
   */


  /*
 * ============================================================
 * RESTORE SELECTED FILTERS FROM URL
 * ============================================================
 *
 * When page is refreshed:
 * custom_filter is already present in URL.
 *
 * This function:
 * 1. Reads custom_filter
 * 2. Decodes Base64
 * 3. Restores matching checkboxes
 * 4. Updates selected filter chips
 * 5. Loads filtered products again
 *
 * ============================================================
 */

function restoreFiltersFromURL() {

  var url =
    new URL(
      window.location.href
    );

  var encoded =
    url.searchParams.get(
      'custom_filter'
    );

  /*
   * No custom filter in URL.
   */
  if (!encoded) {
    return false;
  }

  try {

    /*
     * Decode Base64 -> UTF-8 JSON
     */
    var decoded =
      decodeURIComponent(
        escape(
          atob(encoded)
        )
      );

    var selected =
      JSON.parse(
        decoded
      );

    if (
      !Array.isArray(selected) ||
      !selected.length
    ) {
      return false;
    }

    console.log(
      'CUSTOM FILTER: RESTORING FILTERS FROM URL:',
      selected
    );

    /*
     * ----------------------------------------------------------
     * FIND ORIGINAL DESKTOP CHECKBOXES
     * ----------------------------------------------------------
     */

    var checkboxes =
      groupsContainer.querySelectorAll(
        'input[type="checkbox"]'
      );

    /*
     * First uncheck everything.
     */
    checkboxes.forEach(
      function (checkbox) {

        checkbox.checked =
          false;

      }
    );

    /*
     * ----------------------------------------------------------
     * RESTORE SELECTED CHECKBOXES
     * ----------------------------------------------------------
     */

    selected.forEach(
      function (selectedFilter) {

        if (!selectedFilter) {
          return;
        }

        var valueId =
          selectedFilter.valueId || '';

        var filterId =
          selectedFilter.filterId || '';

        /*
         * Match by valueId + filterId.
         */
        checkboxes.forEach(
          function (checkbox) {

            if (
              checkbox.dataset.valueId ===
                valueId &&
              checkbox.dataset.filterId ===
                filterId
            ) {

              checkbox.checked =
                true;

            }

          }
        );

      }
    );

    /*
     * ----------------------------------------------------------
     * GET RESTORED FILTERS
     * ----------------------------------------------------------
     */

    var restoredSelected =
      getSelectedFilters();

    if (
      !restoredSelected.length
    ) {

      console.warn(
        'CUSTOM FILTER: URL filters found, but matching checkboxes were not found.'
      );

      return false;
    }

    /*
     * ----------------------------------------------------------
     * UPDATE UI
     * ----------------------------------------------------------
     */

    updateClearButton();

    renderSelectedFilters();

    /*
     * ----------------------------------------------------------
     * CREATE API FILTER ARRAY
     * ----------------------------------------------------------
     */

    var apiFilters =
      restoredSelected.map(
        function (item) {
          return item.input;
        }
      );

    /*
     * ----------------------------------------------------------
     * RESTORE PAGE
     * ----------------------------------------------------------
     */

    var pageNumber =
      Number(
        url.searchParams.get(
          'page'
        )
      ) || 1;

    if (
      pageNumber < 1
    ) {
      pageNumber = 1;
    }

    currentFilteredApiFilters =
      apiFilters;

    currentFilteredPage =
      pageNumber;

    filteredPageCursors = {
      1: null
    };

    /*
     * ----------------------------------------------------------
     * LOAD FILTERED PRODUCTS
     * ----------------------------------------------------------
     *
     * Page 1:
     * direct API request.
     *
     * Page > 1:
     * existing cursor pagination function.
     */

    if (
  pageNumber > 1
) {

  currentFilteredApiFilters =
    apiFilters;

  requestFilteredPage(
    pageNumber
  );

} else {

  loadFilteredProducts(
    apiFilters,
    null,
    1
  );

}

    return true;

  } catch (error) {

    console.error(
      'CUSTOM FILTER: URL RESTORE ERROR:',
      error
    );

    return false;
  }

}

  loadFilters();

  /*
   * ============================================================
   * PUBLIC DEBUG OBJECT
   * ============================================================
   */

  window.CustomLargeCollectionFilter = {

    getSelectedFilters:
      getSelectedFilters,

    applyFilters:
      applyFilters,

    restoreOriginalCollection:
      restoreOriginalCollection,

    saveOriginalZellisProducts:
      saveOriginalZellisProducts,

    restoreOriginalZellisFallback:
      restoreOriginalZellisFallback,

    loadFilteredProducts:
      loadFilteredProducts
  };

  console.log(
    'CUSTOM LARGE COLLECTION FILTER: READY'
  );



  /*
 * ============================================================
 * UPDATE PRODUCT TOTAL COUNT
 * ============================================================
 *
 * Example:
 *
 * 23 of 2612 products
 *
 * ============================================================
 */


/*
 * ============================================================
 * PRESERVE CUSTOM FILTER WHEN PAGINATION IS CLICKED
 * ============================================================
 *
 * For collections > 5000 products:
 * - Keep selected custom filters
 * - Prevent Shopify normal pagination navigation
 * - Load filtered API page instead
 *
 * Search page / Part Finder are NOT affected because
 * this script only exists when #custom-large-collection-filters
 * exists.
 *
 * ============================================================
 */

function initCustomFilterPagination() {

  /*
   * Only run when custom large collection filter exists.
   */
  if (
    !document.getElementById(
      'custom-large-collection-filters'
    )
  ) {
    return;
  }

  /*
   * ----------------------------------------------------------
   * FIND SHOPIFY PAGINATION
   * ----------------------------------------------------------
   */

  var paginationLinks =
    document.querySelectorAll(
      '.shopify_desk .pagination a'
    );

  /*
   * Some themes use different pagination wrappers.
   * Add fallback selectors.
   */

  if (!paginationLinks.length) {
    paginationLinks =
      document.querySelectorAll(
        '.shopify_desk a[href*="?page="]'
      );
  }

  if (!paginationLinks.length) {
    paginationLinks =
      document.querySelectorAll(
        '.shopify_desk a[href*="page="]'
      );
  }

  if (!paginationLinks.length) {
    console.log(
      'CUSTOM FILTER: No Shopify pagination links found.'
    );

    return;
  }

  console.log(
    'CUSTOM FILTER: Pagination links found:',
    paginationLinks.length
  );

  /*
   * ----------------------------------------------------------
   * ADD CLICK HANDLER
   * ----------------------------------------------------------
   */

  paginationLinks.forEach(
    function (link) {

      /*
       * Prevent duplicate listeners.
       */
      if (
        link.dataset.customFilterPaginationBound ===
        'true'
      ) {
        return;
      }

      link.dataset.customFilterPaginationBound =
        'true';

      link.addEventListener(
        'click',
        function (event) {

          /*
           * ----------------------------------------------------
           * CHECK SELECTED FILTERS
           * ----------------------------------------------------
           */

          var selected =
            getSelectedFilters();

          /*
           * If no custom filter is selected,
           * allow Shopify's normal pagination.
           */
          if (
            !selected ||
            !selected.length
          ) {
            return;
          }

          /*
           * ----------------------------------------------------
           * PREVENT NORMAL SHOPIFY PAGE LOAD
           * ----------------------------------------------------
           */

          event.preventDefault();
          event.stopPropagation();

          /*
           * ----------------------------------------------------
           * GET TARGET PAGE
           * ----------------------------------------------------
           */

          var href =
            link.getAttribute('href') ||
            '';

          var targetUrl;

          try {

            targetUrl =
              new URL(
                href,
                window.location.origin
              );

          } catch (error) {

            console.error(
              'CUSTOM FILTER: Invalid pagination URL.',
              error
            );

            return;
          }

          var pageNumber =
            Number(
              targetUrl.searchParams.get(
                'page'
              )
            );

          /*
           * Default page.
           */
          if (
            !pageNumber ||
            pageNumber < 1
          ) {
            pageNumber = 1;
          }

          console.log(
            'CUSTOM FILTER: Pagination clicked:',
            pageNumber
          );

          /*
           * ----------------------------------------------------
           * API FILTERS
           * ----------------------------------------------------
           */

          var apiFilters =
            selected.map(
              function (item) {
                return item.input;
              }
            );

          /*
           * ----------------------------------------------------
           * CHECK CURSOR
           * ----------------------------------------------------
           */

          var afterCursor =
            filteredPageCursors[
              pageNumber
            ];

          /*
           * Page 1 always uses null.
           */
          if (
            pageNumber === 1
          ) {
            afterCursor = null;
          }

          /*
           * If requested page cursor is not available,
           * load pages sequentially until the cursor becomes
           * available.
           */
          if (
            pageNumber > 1 &&
            !afterCursor
          ) {

            console.log(
              'CUSTOM FILTER: Cursor not available for page:',
              pageNumber
            );

            loadFilteredPageByCursor(
              apiFilters,
              pageNumber
            );

            return;
          }

          /*
           * ----------------------------------------------------
           * SAVE CURRENT FILTER STATE
           * ----------------------------------------------------
           */

          currentFilteredApiFilters =
            apiFilters;

          currentFilteredPage =
            pageNumber;

          /*
           * ----------------------------------------------------
           * UPDATE URL
           * ----------------------------------------------------
           *
           * IMPORTANT:
           *
           * Keep custom_filter.
           * Only change page.
           */

          preserveCustomFilterPageInURL(
            pageNumber
          );

          /*
           * ----------------------------------------------------
           * LOAD FILTERED API PRODUCTS
           * ----------------------------------------------------
           */

          loadFilteredProducts(
            apiFilters,
            afterCursor || null,
            pageNumber
          );

          /*
           * ----------------------------------------------------
           * SCROLL TO PRODUCT GRID
           * ----------------------------------------------------
           */

          setTimeout(
            function () {

              var productGrid =
                document.querySelector(
                  '.product-grid-container.shopify_desk'
                );

              if (
                productGrid
              ) {

                var rect =
                  productGrid.getBoundingClientRect();

                var scrollTop =
                  window.pageYOffset +
                  rect.top -
                  120;

                window.scrollTo({
                  top: scrollTop,
                  behavior: 'smooth'
                });

              }

            },
            100
          );

        },
        true
      );

    }
  );
}


/*
 * ============================================================
 * UPDATE URL WITHOUT REMOVING custom_filter
 * ============================================================
 */

function preserveCustomFilterPageInURL(
  pageNumber
) {

  var url =
    new URL(
      window.location.href
    );

  /*
   * Make sure custom_filter exists.
   */
  var customFilter =
    url.searchParams.get(
      'custom_filter'
    );

  /*
   * If custom_filter is missing,
   * rebuild it from currently selected filters.
   */
  if (
    !customFilter
  ) {

    var selected =
      selectedInputsToURL();

    if (
      selected &&
      selected.length
    ) {

      try {

        var encoded =
          btoa(
            unescape(
              encodeURIComponent(
                JSON.stringify(
                  selected
                )
              )
            )
          );

        url.searchParams.set(
          'custom_filter',
          encoded
        );

      } catch (error) {

        console.error(
          'CUSTOM FILTER: Unable to encode filters.',
          error
        );

      }

    }

  }

  /*
   * Set requested page.
   */
  if (
    pageNumber > 1
  ) {

    url.searchParams.set(
      'page',
      pageNumber
    );

  } else {

    url.searchParams.delete(
      'page'
    );

  }

  /*
   * Update browser URL.
   */
  window.history.pushState(
    {
      customFilterPagination: true
    },
    '',
    url.toString()
  );

  console.log(
    'CUSTOM FILTER: URL updated:',
    url.toString()
  );
}


/*
 * ============================================================
 * LOAD PAGE WHEN CURSOR IS NOT YET AVAILABLE
 * ============================================================
 *
 * Shopify Storefront API uses cursor pagination.
 *
 * Example:
 *
 * page 1 -> cursor for page 2
 * page 2 -> cursor for page 3
 * page 3 -> cursor for page 4
 *
 * Therefore, if user directly clicks page 5,
 * we first build the required cursors.
 *
 * ============================================================
 */

function loadFilteredPageByCursor(
  apiFilters,
  targetPage
) {

  /*
   * Page 1 is already available.
   */
  if (
    targetPage <= 1
  ) {

    preserveCustomFilterPageInURL(
      1
    );

    loadFilteredProducts(
      apiFilters,
      null,
      1
    );

    return;
  }

  /*
   * Find the highest cursor we currently have.
   */
  var knownPage =
    1;

  Object.keys(
    filteredPageCursors
  ).forEach(
    function (page) {

      var number =
        Number(page);

      if (
        number <= targetPage &&
        filteredPageCursors[page] !==
          undefined
      ) {

        if (
          number > knownPage
        ) {
          knownPage =
            number;
        }

      }

    }
  );

  /*
   * If target cursor is already available,
   * load directly.
   */
  if (
    filteredPageCursors[
      targetPage
    ] !== undefined
  ) {

    var directCursor =
      filteredPageCursors[
        targetPage
      ];

    preserveCustomFilterPageInURL(
      targetPage
    );

    loadFilteredProducts(
      apiFilters,
      directCursor || null,
      targetPage
    );

    return;
  }

  /*
   * ----------------------------------------------------------
   * LOAD NEXT PAGE SEQUENTIALLY
   * ----------------------------------------------------------
   */

  var nextPage =
    knownPage;

  function loadNextCursor() {

    /*
     * Cursor for current page.
     */
    var currentCursor =
      filteredPageCursors[
        nextPage
      ];

    /*
     * Load current page only to obtain
     * the next cursor.
     *
     * We do not render intermediate pages.
     */
    getFilteredPageInfoOnly(
      apiFilters,
      currentCursor || null
    )
      .then(
        function (pageInfo) {

          if (
            !pageInfo
          ) {

            console.error(
              'CUSTOM FILTER: Unable to get page cursor.'
            );

            return;
          }

          /*
           * Save next page cursor.
           */
          if (
            pageInfo.endCursor
          ) {

            filteredPageCursors[
              nextPage + 1
            ] =
              pageInfo.endCursor;

          }

          /*
           * Target cursor is now available.
           */
          if (
            nextPage + 1 >=
            targetPage
          ) {

            var targetCursor =
              filteredPageCursors[
                targetPage
              ];

            preserveCustomFilterPageInURL(
              targetPage
            );

            loadFilteredProducts(
              apiFilters,
              targetCursor || null,
              targetPage
            );

            return;
          }

          /*
           * Continue.
           */
          nextPage++;

          if (
            pageInfo.hasNextPage
          ) {

            loadNextCursor();

          } else {

            console.warn(
              'CUSTOM FILTER: Target page does not exist.'
            );

          }

        }
      )
      .catch(
        function (error) {

          console.error(
            'CUSTOM FILTER: Cursor loading error:',
            error
          );

        }
      );

  }

  loadNextCursor();
}


/*
 * ============================================================
 * GET PAGE INFO ONLY
 * ============================================================
 *
 * Used only for building pagination cursors.
 *
 * ============================================================
 */

function getFilteredPageInfoOnly(
  apiFilters,
  afterCursor
) {

  var query = `
    query FilteredCollectionPageInfo(
      $handle: String!,
      $filters: [ProductFilter!],
      $after: String
    ) {

      collection(
        handle: $handle
      ) {

        products(
          first: 24,
          after: $after,
          filters: $filters
        ) {

          pageInfo {

            hasNextPage

            hasPreviousPage

            startCursor

            endCursor

          }

        }

      }

    }
  `;

  return shopifyRequest(
    query,
    {
      handle:
        collectionHandle,

      filters:
        apiFilters,

      after:
        afterCursor || null
    }
  )
    .then(
      function (result) {

        var collection =
          result &&
          result.data &&
          result.data.collection;

        if (
          !collection ||
          !collection.products
        ) {

          throw new Error(
            'Unable to get filtered page information.'
          );

        }

        return (
          collection.products.pageInfo ||
          null
        );

      }
    );

}


/*
 * ============================================================
 * INITIALIZE
 * ============================================================
 *
 * Wait until Shopify has rendered pagination.
 * ============================================================
 */

function setupCustomFilterPagination() {

  initCustomFilterPagination();

  /*
   * Shopify may render/update the collection section
   * after initial page load.
   *
   * Re-bind after a short delay.
   */

  setTimeout(
    function () {
      initCustomFilterPagination();
    },
    500
  );

  setTimeout(
    function () {
      initCustomFilterPagination();
    },
    1200
  );

}


/*
 * Start pagination handler.
 */

setupCustomFilterPagination();

  /*
   * Shopify can replace the SortBy select during section
   * rendering, so bind once now and retry after render.
   */
  bindCustomSortPreservation();

  setTimeout(
    function () {
      bindCustomSortPreservation();
    },
    300
  );

  setTimeout(
    function () {
      bindCustomSortPreservation();
    },
    1000
  );


})();